import koLocale from 'element-ui/lib/locale/lang/ko'

export default {
  LanguageLib: {
    _THE_SYSTEM_WILL_AUTOMATICALLY_COMPRESS_THE_PICTURE_INTO_2000_STAR_2000_AND_UPLOAD: 'The system will automatically resize photo to 2000*2000 and upload it',
    ABOUT_PAGE_MAP: 'About web page photo',
    ACCEPT_PICTURE_CONFIGURATION: 'Accept image configurations',
    ACCEPTANCE_REPORT: 'Acceptance reports',
    ACCEPTANCE_SCORE_IS_REQUIRED: 'Scores is required?',
    ACCESSORIES_NAME: 'Accessories name',
    ACCESSORY_NAME: 'Attachment name',
    ACCOUNT: 'Account number',
    ExcelTemplate_common_000009: 'Account number',
    ACCOUNT_NUMBER: 'Account number',
    ACTIVATION: 'Activation',
    ACTUAL_SCORE: 'Actual score',
    ADD_A_STORE_CAMERA: 'Add a store camera',
    ADD_ASSET_TYPE: 'Add asset type',
    ADD_ASSET_TYPE_FAILED: 'Add asset type failed',
    ADD_BRAND: 'Add brand',
    ADD_BRAND_TYPE: 'Add a brand type',
    ADD_CAMERA_INFORMATION: 'Add camera information',
    ADD_CATEGORY: 'Add category',
    ADD_CATEGORY_NAME_CANNOT_BE_KEYWORDS_FOR_SHOP_PROVINCE_CITY_COUNTRY_ETC: 'Category name cannot as the keywords for stores, provinces, cities, countries, etc.',
    ADD_CONTACT: 'Add contact person',
    ADD_COURSE: 'Add course',
    ADD_COURSEWARE: 'Add courseware',
    ADD_DATA_ON_THE_REPORT_SHEET: 'Add data on report sheet:',
    ADD_DATE: 'Add date',
    ADD_DEALER: 'Add vendor',
    ADD_DEALER_TYPE: 'Add vendor type',
    ADD_DEFECTIVE_PARTS: 'Add defective parts',
    ADD_DEFECTIVE_PRODUCT_CLASSIFICATION: 'Add defective product category',
    ADD_DISTRIBUTOR_CORPORATE: 'Add vendor',
    ADD_EMPLOYEE: 'Add staff',
    ADD_FAILED: 'Add failed',
    ADD_FAILED_BUSINESS_START_TIME_CANNOT_BE_LESS_THAN_END_TIME: 'Add failed - business start time must be greater than end time',
    ADD_FAILED_DO_NOT_ADD_EXISTING_NONCUSTOM_ORGANIZATION: 'Add failed - cannot add existing non-defined organization',
    ADD_FAILED_NO_CORRECT_ANSWER_EXISTS_IN_OPTIONS: 'Add failed - no correct answer exists in options',
    ADD_FAILED_START_TIME_CANNOT_BE_GREATER_THAN_END_TIME: 'Add failed - start time cannot greater than end time',
    ADD_FAILED_START_TIME_CANNOT_BE_LESS_THAN_TODAY: 'Add failed - start time must be greater than today',
    ADD_FAILED_THE_ACCOUNT_IS_NOT_A_SUPPLIER_USER: 'Add failed - this account is not a vendor account',
    ADD_FAILED_THE_BRAND_ALREADY_EXISTS: 'Add failed - this brand already exists',
    ADD_FAILED_THE_PHONE_NUMBER_USER_ALREADY_EXISTS: 'Add failed - this mobile phone number user already exists',
    ADD_FAILED_THE_SAME_ORGANIZATION_OR_STORE_NAME_ALREADY_EXISTS: 'Add failed - same organization or store name already exists',
    ADD_FAILED_THE_TEMPLATE_NAME_ALREADY_EXISTS: 'Add failed - this template name already exists',
    ADD_FAILED_WITH_AT_LEAST_TWO_OPTIONS_FOR_A_TOPIC: 'Add failed - at least two options in a subject',
    ADD_FAILED1: 'Add failed,',
    ADD_FAILED2: 'Add failed!',
    ADD_FAILED3: 'Add failed:',
    ADD_FILE_TYPE: 'Add file type',
    ADD_FOLDER: 'Add folder',
    ADD_GENERAL_DATA: 'Add general data',
    ADD_GREETING_RETURN_VISIT_TYPE: 'Add return visit type',
    ADD_HISTORICAL_EXCHANGE_RATES: 'Add historical exchange rates',
    ADD_ITEM_CATEGORY_SUCCESSFULLY: 'Add prop category successfully',
    ADD_JOB: 'Add position',
    ADD_MAINTENANCE_PROBLEM_CLASSIFICATION: 'Add maintenance issue category',
    ADD_MAINTENANCE_QUESTION: 'Add maintenance issue',
    ADD_NEW_LABEL: 'Add new tag',
    ADD_ORGANIZATION: 'Add organization',
    ADD_ORGANIZATION_NODE_SUCCESSFULLY: 'Add organization note successfully',
    ADD_ORGANIZATION_TYPE: 'Add organization type',
    ADD_PASSENGER_FLOW: 'Add customer flow',
    ADD_PASSENGER_FLOW_ADJUSTMENTS: 'Add customer flow adjustment',
    ADD_PEOPLE: 'Add staff',
    ADD_PERSON_FAILED: 'Add staff failed',
    ADD_PERSONNEL_ASSESSMENT_TEMPLATE_QUESTIONS: 'Add staff assessment question template',
    ADD_PURCHASE_RECORD: 'Add purchase record',
    ADD_PURCHASE_RECORD_FAILED: 'Add purchase record failed',
    ADD_QUESTION: 'Add questions',
    ADD_QUESTION_BANK_QUESTIONS: 'Add question',
    ADD_REGION: 'Add location',
    ADD_RELATIONSHIP: 'Add relationship',
    ADD_RETAIL_TOUR_TEMPLATE: 'Add checklist item category',
    ADD_ROLE: 'Add role',
    ADD_SALES: 'Add sales',
    ADD_SALES_DATA: 'Add sales data',
    ADD_SHOP: 'Add store',
    ADD_SHOP_EQUIPMENT: 'Add store device',
    ADD_SHOP_TYPE: 'Add store type',
    ADD_SUPPLIER: 'Add vendor',
    ADD_TAG: 'Add tag',
    ADD_TASK_TYPE: 'Add task type',
    ADD_TEMPLATE: 'Add template',
    ADD_TEST_PAPER: 'Add exam paper',
    ADD_TEST_QUESTIONS: 'Add exam question',
    ADD_TIME: 'Add time',
    ADD_TO: 'Add to',
    ADD_TO_TEST_PAPER: 'Add to exam paper',
    ADD_TRANSFER_LABEL: 'Add transfer tag',
    ADD_USER_REFERENCE: 'Add user reference',
    ADD_VENDOR_TYPE: 'Add vendor type',
    ADDED_SUCCESSFULLY: 'Added successfully',
    ADDED_SUCCESSFULLY1: 'Added successfully!',
    ADDING_A_STORE_CAMERA_FAILED: 'Add store camera failed',
    ADDING_A_STORE_FAILED: 'Add store failed',
    ADDING_ASSETS: 'Add assets',
    ADDING_COMPETITION_CATEGORY_SUCCESSFUL: 'Add competing product category successful',
    ADDING_COMPETITOR_CATEGORY_FAILED: 'Add competing product category failed',
    ADDING_CUSTOM_FIELDS: 'Add custom field',
    ADDING_CUSTOM_FIELDS_FAILED: 'Add custom field failed',
    ADDING_DEFECTIVE_PARTS_FAILED: 'Add defective parts failed',
    ADDING_DEFECTIVE_PRODUCT_CLASSIFICATION_FAILED: 'Add defective problem category failed',
    ADDING_FAILED_THE_NUMBER_OF_ORGANIZATIONS_IN_THE_ORGANIZATION_HAS_REACHED_THE_UPPER_LIMIT: 'Add failed - the number of organizations in the organization has reached the maximum limit',
    ADDING_GENERIC_DATA_FAILED: 'Add general data failed',
    ADDING_MAINTENANCE_ISSUES_FAILED: 'Add maintenance issue failed',
    ADDING_ORGANIZATION_NODE_FAILED: 'Add organization node failed',
    ADDING_PASSENGER_FLOW_FAILED: 'Add customer flow failed',
    ADDING_RETAIL_TOUR_TEMPLATES: 'Add checklist item',
    ADDING_STORE_EQUIPMENT_FAILED: 'Add store device failed',
    ADDING_USER_REFERENCE_FAILED: 'Add user reference failed',
    ADJUSTMENT_COEFFICIENT: 'Adjustment coefficient',
    ADJUSTMENT_INFORMATION: 'Adjusting information',
    ADMINISTRATOR: 'Administrator',
    AFFILIATES: 'Affiliates',
    AFTER_DELETING_THE_COURSE_ALL_THE_COURSEWARE_IN_THE_COURSE_WILL_BE_DELETED_TOGETHER_PLEASE_CONFIRM_WHETHER_TO_DELETE: 'Deleting a course also removes all courseware inside of it. Are you sure you want to delete the course?',
    AFTER_THE_PHONE_NUMBER: 'After the mobile phone number',
    AGE: 'Age',
    AGREEMENT_CONTENT_CANNOT_BE_EMPTY: 'Agreement content cannot be empty',
    AGREEMENT_DOWNLOAD: 'Download agreement',
    AGREEMENT_MUST_BE_SIGNED_AT_LOGIN: 'Agreement must be signed at login',
    ALL: 'All',
    ALL_TAGS: 'All tags',
    ALL_UNSAVED_CHANGES_HAVE_BEEN_UNDONE: 'All unsaved changes have been revoked',
    ALLOW_EXPORT_OF_CONTACTS: 'Allow export of contacts',
    ALLOW_MULTIPLE_PEOPLE: 'Allow multiple',
    ALLOWS_MODIFICATION_OF_SCORES_WHEN_ENTRIES_ARE_NOT_UP_TO_STANDARD: 'Allows modification of scores when entries are not up to standard',
    ALREADY_COPIED_TO_THE_CLIPBOARD: 'Already copied to the clipboard!',
    ALREADY_HAVE_THE_SAME_AREA_CODE: 'Same location code already exists;',
    ALREADY_HAVE_THE_SAME_ORGANIZATION_OR_SHOP_NAME: 'Same organization or store already exists',
    worker_common_000009: 'Same organization or store already exists',
    ALREADY_HAVE_THIS_OPTION: 'The option already exists',
    AN_AREA_WITH_THE_SAME_NAME_ALREADY_EXISTS: 'Location with the same name already exists;',
    AN_ERROR_OCCURRED: 'An error occurred:',
    AN_ORGANIZATION_WITH_THE_SAME_NAME_ALREADY_EXISTS: 'Same organization name already exists',
    AN_UNKNOWN_ERROR_OCCURRED: 'Unknown error occurred',
    ANNEX: 'Attachment',
    ANNIVERSARY: 'Anniversary',
    ANNOUNCER: 'Publisher',
    ANSWER: 'Answer',
    ANSWER_CASE: 'Answer',
    ANSWER_NUMBER: 'Answer number',
    APPLY_FOR_REPAIRS_AND_PROPS: 'Submit image configurations for maintenance and prop application',
    ARE_YOU_SATISFIED: 'Are you satisfied?',
    ARE_YOU_SURE_TO_DISABLE: 'Are you sure to disable?',
    ARE_YOU_SURE_TO_DOWNLOAD_THE_REPAIR_CODE: 'Are you sure you want to download the maintenance code?',
    ARE_YOU_SURE_TO_FREEZE: 'Are you sure to freeze?',
    ARE_YOU_SURE_TO_GENERATE_A_REPAIR_CODE: 'Are you sure you want to  generate a maintenance code?',
    ARE_YOU_SURE_TO_UNFREEZE: 'Are you sure to enable?',
    ARE_YOU_SURE_YOU_WANT_TO_ADD_FROM_THE_QUESTION_BANK: 'Are you sure you want to add from the question bank?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT: 'Are you sure you want to delete?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1: 'Are you sure you want to delete?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_COURSEWARE: 'Are you sure you want to delete selected subject?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_EXAM: 'Are you sure you want to delete selected exam question(s)?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_TEST_PAPER: 'Are you sure you want to delete selected exam paper(s)?',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_QUESTION: 'Are you sure you want to delete this question?',
    ARE_YOU_SURE_YOU_WANT_TO_ENABLE_IT: 'Confirm to enable?',
    ARE_YOU_SURE_YOU_WANT_TO_RESET_THE_USER_PASSWORD: 'Are you sure you want to reset the user password?',
    ARE_YOU_SURE_YOU_WANT_TO_RESET_THE_USER_PASSWORD1: 'Are you sure you want to reset the user password?',
    ARE_YOU_SURE_YOU_WANT_TO_SEND_THE_MESSAGE: 'Are you sure you want to send the message?',
    AREA: 'Location',
    AREA_CODE: 'Location code',
    AREA_INFORMATION: 'Location information',
    AREA_INFORMATION_ADDED: 'Add location information',
    AREA_INFORMATION_UPDATE: 'Update location information',
    AREA_NAME: 'Location name',
    AREA1: 'Location',
    ARTICLE_NUMBER: 'Product code',
    ASSET_CATALOG: 'Asset catalog',
    ASSET_CATALOG_SETTINGS: 'Asset catalog settings',
    ASSET_CLASS_INFORMATION: 'Asset category information',
    ASSET_CONTENT_SETTINGS: 'Asset content settings',
    ASSET_INFORMATION: 'Asset information',
    ASSET_NAME: 'Asset name',
    ASSET_NUMBER: 'Asset code',
    ASSIGN_TASKS_IMMEDIATELY_AFTER_SUBMITTING_REPORT: 'Assign task immediately after submitting report',
    ASSOCIATED_USER: 'Associated user',
    ATTACHMENT: 'Attachment',
    ATTACHMENT_ID_DOES_NOT_EXIST: 'Attachment ID does not exist',
    ATTACHMENT_TYPE: 'Attachments type',
    AUTHOR: 'Created by',
    AUTHORITY: 'Permission',
    AUTHORIZATION_MANAGEMENT: 'Authorization management',
    AUTOAPPROVED_CATEGORIES_MUST_SELECT_THE_DEFAULT_VENDOR: 'Auto-approval category must select the default vendor',
    AUTOMATIC_APPROVAL: 'Automatic approve',
    AVERAGE_NUMBER_OF_TRANSACTIONS: 'Average number of transactions',
    AVERAGE_PASSENGER_FLOW: 'Average customer flow',
    AVERAGE_SALES: 'Average sales',
    AVERAGE_TRANSACTION_AMOUNT: 'Average transaction amount',
    BACKUP_PHONE: 'Alternate phone',
    BAIDU_MAP_API_CUSTOM_MAPS_TO_HELP_USERS_GENERATE_BAIDU_MAPS_UNDER_VISUAL_OPERATION: 'Baidu Map API custom maps help users generate Baidu map under visualization',
    BAIDU_MAP_BAIDU_MAP_API_BAIDU_MAP_CUSTOMIZATION_TOOL_BAIDU_MAP_WYSIWYG_TOOL: 'Baidu Map, Baidu Map API, Baidu Map Customization Tool, Baidu Map WYSIWYG Tool',
    BASE_FIELD: 'Basic field',
    BASIC_CONFIGURATION: 'Basic configurations',
    BASIC_DATA_IMPORT: 'Basic data import',
    BASIC_INFORMATION: 'Basic information',
    BASIC_SETTINGS: 'Basic settings',
    BATCH_DOWNLOAD: 'Batch download',
    BATCH_TAG: 'Batch tag',
    BEGINNING_NUMBER: 'Initial quantity',
    BEGINNING_TIME: 'Start time',
    BIND_MAILBOX: 'Bind email',
    BIND_PHONE_NUMBER: 'Bind mobile phone number',
    BINDING_RELATIONSHIP: 'Bind relationship',
    BIRTH_DAY: 'Birthday',
    BIRTHDAY: 'Birthday',
    ExcelTemplate_common_000018: 'Birthday',
    BIT: 'Bit',
    BRAND: 'Brand',
    BRAND_ADDITION: 'Add brand',
    BRAND_CATEGORIES_IN_USE_CANNOT_BE_DELETED: 'Brand category is in used and cannot be deleted!',
    BRAND_CATEGORIES_IN_USE_CANNOT_BE_DELETED1: 'Brand category is in used and cannot be deleted!',
    BRAND_CATEGORY: 'Brand category',
    BRAND_CATEGORY_DOES_NOT_EXIST: 'Brand category does not exist',
    BRAND_CATEGORY1: 'Brand category',
    BRAND_CUSTOMERS: 'Brand customer',
    BRAND_DATA_IMPORT: 'Import brand data',
    BRAND_DATA_TEMPLATE: 'Brand data template',
    BRAND_INFORMATION: 'Brand information',
    BRAND_INTRODUCTION: 'Brand introduction',
    BRAND_NAME: 'Brand name',
    BRAND_REMOVAL_FAILED: 'Delete brand failed',
    BRAND_SETTINGS: 'Brand setup',
    BRAND_TYPE: 'Brand type',
    BRAND_TYPE_DOES_NOT_EXIST: 'Brand type does not exist;',
    BRAND_TYPE_INFORMATION: 'Brand type information',
    BRAND_TYPE_NAME: 'Brand type name',
    BRAND_TYPE_NUMBER: 'Brand type code',
    BRAND_UPDATE: 'Brand update',
    BROADCAST: 'Broadcast',
    BUILD_FAILED: 'Build failed',
    BUILD_FAILED1: 'Build failed:',
    BUILD_TIME: 'Build time',
    BULK_ENABLE: 'Batch enabled',
    BUSINESS_HOURS: 'Business hour',
    BY: 'Passed',
    BY_SERIAL_NUMBER: 'By serial number',
    BY_UPDATE_TIME: 'By update time',
    CALL_DURATION: 'Call duration',
    CAMERA_ADDRESS: 'Camera address',
    CAMERA_INFORMATION: 'Camera information',
    CAMERA_INFORMATION_ADDED: 'Add camera information',
    CAMERA_INFORMATION_UPDATE: 'Camera information update',
    CAMERA_NAME: 'Camera name',
    CAN_NOT_BE_EMPTY: 'Cannot be empty',
    CAN_NOT_BE_EMPTY1: 'Cannot be empty;',
    CANCEL: 'Cancel',
    CANNOT_BE_DELETED: 'Cannot delete',
    CANNOT_EDIT_CURRENCY_NAME: 'Cannot edit currency name',
    CATEGORIES: 'Product categories',
    CATEGORY: 'Category',
    CATEGORY_CODE: 'Category code',
    CATEGORY_DESCRIPTION: 'Category description',
    CATEGORY_DETAILS: 'Category details',
    CATEGORY_INFORMATION: 'Category information',
    CATEGORY_NAME: 'Category name',
    CATEGORY_NUMBER: 'Category code',
    CATEGORY_NUMBER1: 'Category number',
    CATEGORY_UNIQUE_ID_CANNOT_BE_EMPTY: 'Category unique ID cannot be empty',
    CATEGORY1: 'Category',
    CC: 'CC',
    CHANGE_PASSWORD_AT_FIRST_LOGIN: 'Change password at first login',
    CHANNEL_DESCRIPTION: 'Channel description',
    CHANNEL_DESCRIPTION_CANNOT_EXCEED_1000_WORDS: 'Channel description cannot exceed 1000 characters',
    CHANNEL_LIST: 'Channel list',
    CHANNEL_NAME: 'Channel name',
    CHANNEL_NUMBER: 'Channel code',
    CHANNEL_NUMBERS_CANNOT_BE_DUPLICATED: 'Channel code cannot repeat',
    CHANNEL_TYPE: 'Channel type',
    CHARACTER_LENGTH_EXCEEDS: 'Character length exceeds',
    CHARACTER_LENGTH_EXCEEDS_THE_LIMIT: 'Character length exceeds the limit;',
    CHECK_BRAND: 'Search brand',
    CHECK_IN_TIME: 'Check-in time',
    CHECK_THE_PROMPT_FILE: ', check the log file?',
    CHECKED_FIELDS_ARE_SHOWN_UNCHECKED_ARE_HIDDEN_FIELDS: 'Checked are display field, unchecked are hidden field',
    CHILDREN_S_SITUATION: "Children's status",
    CHINESE_SIMPLIFIED: 'Chinese Simplified',
    CHOICE_1: 'Option 1',
    CHOICE_2: 'Option 2',
    CHOICE_3: 'Option 3',
    CHOICE_4: 'Option 4',
    CHOICE_5: 'Option 5',
    CHOOSE_A_STORE: 'Select store',
    CHOOSE_FROM_A_QUESTION_BANK: 'Select from question bank',
    CLASSIFICATION: 'Category',
    CLASSIFICATION_NAME: 'Category name',
    CLASSIFICATION_RENAME: 'Rename category',
    CLEAR: 'Clear',
    CLIENT: 'Customer',
    CLIENTS_NAME: 'Customer name',
    CODE_REFRESH: 'Code refresh',
    CODING: 'Code',
    CODING_CANNOT_BE_REPEATED: 'Code cannot be repeated',
    COLLAPSE: 'Collapse',
    PUT_AWAY: 'Collapse',
    COMMENT: 'Comment',
    COMMENT_BY: 'Commented by',
    COMMENT_TIME: 'Comment time',
    COMMODITY_CATEGORY: 'Major product category',
    COMMODITY_ORGANIZATION_RELATIONSHIP: 'Product organization relationship',
    COMMODITY_SMALL_CLASS: 'Minor product',
    COMPANY_ADD: 'Add company',
    COMPANY_ADDRESS: 'Company address',
    COMPANY_CONFIGURATION: 'Company configurations',
    COMPANY_DEFAULT_LANGUAGE_CANNOT_BE_EMPTY: 'Company default language cannot be empty;',
    COMPANY_DESCRIPTION: 'Company description',
    COMPANY_DETAILS: 'Company details',
    COMPANY_EMAIL: 'Company email',
    COMPANY_HOMEPAGE_MAP: 'Company homepage photo',
    COMPANY_INFORMATION: 'Company information',
    COMPANY_NAME: 'Company name',
    COMPANY_NUMBER: 'Company code',
    COMPANY_PHONE: 'Company phone',
    COMPETING_PICTURE: 'Competing product image:',
    COMPETITION_CATEGORY: 'Competing product category',
    COMPETITION_CATEGORY_IMPORT: 'Competing product category import',
    COMPETITION_INFORMATION: 'Competing product information',
    COMPETITION_INFORMATION_IMPORT: 'Import competing product information',
    COMPETITION_NUMBER: 'Competing product code',
    COMPETITIVE_DATA_IMPORT: 'Import competing product data',
    COMPETITIVE_NAME: 'Competing product name',
    COMPETITIVE_PRODUCT_CLASSIFICATION_INFORMATION: 'Competing product category information',
    COMPETITIVE_STATUS: 'Competing product status',
    COMPLETE_TIME: 'Complete time',
    COMPLETED: 'Completed',
    COMPLETION_REPORT_CONFIRMATION_TIME: 'Completion report confirmation time',
    COMPLIANCE_SCORE: 'Qualify score',
    CONFIGURATION_ENTRY: 'Entry configurations',
    CONFIRM: 'Confirm',
    CONFIRM_SYNCHRONIZATION_EASY_TO_KNOW_USER_DATA: "Confirm synchronization Easy Learning's user data?",
    CONTACT_ADDRESS: 'Contact address',
    CONTACT_DETAILS: 'Contact Method',
    ExcelTemplate_common_000021: 'Contact information',
    CONTACT_INFORMATION: 'Contact information',
    CONTACT_NAME: 'Contact Person',
    CONTACT_NUMBER: 'Contact Number',
    CONTACT_NUMBER1: 'Contact number',
    CONTACT_PERSON: 'Contact person',
    CONTACT_SETTINGS: 'Contact settings',
    CONTACT_US: 'Contact us',
    CONTENT: 'Content',
    CONTENT1: 'Content:',
    CONTROL_EDITING: 'Edit control',
    CONVERSION_RATE: 'Conversion rate',
    COPIED_TO_CLIPBOARD: 'Copied to clipboard:',
    COPIED_TO_CLIPBOARD1: 'Copied to clipboard',
    COPY: 'Copy',
    COPY_TO_CLIPBOARD_FAILED: 'Copy to clipboard failed',
    CORRECTION_REPORT: 'Rectifying report',
    COURSE_CREATOR: 'Course creator',
    COURSE_DETAILS: 'Course details',
    COURSE_INFORMATION: 'Course information',
    COURSE_MANAGEMENT: 'Course management',
    COURSE_MODIFICATION_TIME: 'Course modification time',
    COURSE_NO: 'Course code',
    COURSE_NOTES: 'Course remarks',
    COURSE_NUMBER: 'Course number',
    COURSE_PICTURES: 'Course image',
    COURSE_TITLE: 'Course title',
    COURSE_TYPE: 'Course type',
    COURSEWARE_ADDED_SUCCESSFULLY: 'Courseware added successfully',
    COURSEWARE_ADDITION_FAILED: 'Add courseware failed',
    COURSEWARE_CODING: 'Courseware coding',
    COURSEWARE_CREATOR: 'Courseware creator',
    COURSEWARE_DETAILS: 'Courseware details',
    COURSEWARE_HOME: 'Courseware homepage',
    COURSEWARE_INFORMATION: 'Courseware information',
    COURSEWARE_MODIFICATION_FAILED: 'Modify courseware failed',
    COURSEWARE_MODIFIED_SUCCESSFULLY: 'Modify courseware succeeded',
    COURSEWARE_NAME: 'Courseware name',
    COURSEWARE_NOTES: 'Courseware remarks',
    COURSEWARE_NUMBER: 'Courseware code',
    COURSEWARE_PICTURE: 'Courseware image',
    COURSEWARE_SERIAL_NUMBER: 'Courseware serial number',
    COURSEWARE_UPLOAD: 'Courseware upload',
    CREATE_DATA: 'Create data',
    CREATION_DATE: 'Date Created',
    CREATION_TIME: 'Time Created',
    CREATOR: 'Created by',
    CROP: 'Crop',
    CURRENCY: 'Currency',
    CURRENCY_NAME: 'Currency name',
    CURRENCY_SETTING: 'Currency settings',
    CURRENCY_TYPE_DOES_NOT_EXIST: 'Currency type does not exist;',
    CURRENCY_TYPE_IS_NOT_ACTIVATED: 'Curency type is inactive;',
    CURRENT_EXCHANGE_RATE_SETTINGS: 'Current exchange rate settings',
    CUSTOM_FIELD: 'Custom field',
    CUSTOM_FIELD_DOES_NOT_EXIST_IN_EXCEL: 'Custom field does not exist in Excel',
    CUSTOM_FIELD_INFORMATION: 'Custom field information',
    CUSTOMER_DATA_IMPORT: 'Import customer data',
    CUSTOMER_DATA_TEMPLATE: 'Customer data template',
    CUSTOMER_INFORMATION: 'Customer information',
    CUSTOMER_LIST: 'Customer list',
    CUSTOMER_MANAGEMENT: 'Customer management',
    CUSTOMER_NAME: 'Customer name',
    CUSTOMER_NICKNAME: 'Customer nickname',
    CUSTOMER_S_NAME: 'Customer name',
    DAILY_PRODUCTS: 'Daily production quantity',
    DAILY_SALES: 'Daily sales',
    DAILY_TRAFFIC: 'Daily customer flow',
    DATA_CLASSIFICATION: 'Data category',
    DATA_ENCODING: 'Data code',
    DATA_ID: 'Data ID',
    DATA_IS_INCORRECT_PLEASE_VERIFY: 'Data error, please check your input data',
    DATA_NAME: 'Data name',
    DATA_PROCESSING_IS_COMPLETE: 'Data processing is completed!',
    DATA_REPORTING: 'Data reporting',
    m_info_common_000036: 'Data Report',
    DATA_REPORTING_MANAGEMENT: 'Data management report',
    DATA_STEWARD: 'Data administrator',
    DATA_TEMPLATE_MANAGEMENT: 'Data template management',
    DATA_TOP_COLLATION: 'Sticky data sorting rule',
    DATA_TYPE_CONVERSION_FAILED_IT_SHOULD_BE_DATE_TYPE: 'Failed to convert data type, it should be date format',
    DATA_TYPE_CONVERSION_FAILED_IT_SHOULD_BE_NUMERIC: 'Failed to convert data type, it sould be numeric',
    DATE: 'Date',
    DATE_RANGE: 'Date range',
    DAY: 'Day',
    DEALER__CORPORATE_MANAGEMENT: 'Vendor management',
    DEALER_ADDED: 'Add vendor',
    DEALER_CORPORATE: 'Vendor',
    DEALER_CORPORATE_INFORMATION: 'Vendor information',
    DEALER_DATA_IMPORT: 'Import vendor data',
    DEALER_LEGAL_NAME: 'Vendor name',
    DEALER_TYPE: 'Vendor type',
    DEALER_TYPE_INFORMATION: 'Vendor type information',
    DEALER_UPDATE: 'Update vendor',
    DECIMAL_PLACES: 'Remain decimal places',
    DECIMALS: 'Remain decimal',
    DECORATION_MAINTENANCE: 'Renovation/ maintenance',
    DECORATION_PERIOD: 'Timeslot for renovation',
    DEFAULT_LANGUAGE: 'Default language',
    DEFAULT_PASSWORD_FORMAT: 'Default password format',
    DEFAULT_PRIORITY: 'Default priority',
    DEFAULT_VENDOR: 'Default vendor',
    DEFECTIVE_PARTS: 'Item part',
    DEFECTIVE_PARTS1: 'Item accessories',
    DEFECTIVE_PRODUCT: 'Issue',
    DEFECTIVE_REPAIR: 'Defect Repair',
    m_info_common_000007: 'Defect Repair',
    DELETE: 'Delete',
    DELETE_A_STAFF_ASSESSMENT_TEMPLATE: 'Delete staff assessment template',
    DELETE_ASSET: 'Delete asset',
    DELETE_ASSET_TYPE: 'Delete asset type',
    DELETE_CATEGORY: 'Delete category',
    DELETE_COMMON_DATA: 'Delete general data',
    DELETE_COURSE: 'Delete course',
    DELETE_COURSEWARE: 'Delete courseware',
    DELETE_CUSTOM_FIELDS: 'Delete custom field',
    DELETE_CUSTOMER: 'Delete customer',
    DELETE_CUSTOMER_FAILED: 'Delete customer failed',
    DELETE_DOCUMENT: 'Delete document',
    DELETE_EXAM_RECORD: 'Delete exam record',
    DELETE_FAILED_THERE_ARE_CHILD_NODES_UNDER_THE_DELETE_NODE: 'Delete failed - There are child nodes under the delete node',
    DELETE_FILE_TYPE: 'Delete file type',
    DELETE_GREETING_RETURN_VISIT_TYPE: 'Delete return visit type',
    DELETE_JOB: 'Delete position',
    DELETE_JOB_SHOP_TEMPLATE: 'Delete store template',
    DELETE_MAINTENANCE_PROBLEM_CLASSIFICATION: 'Delete maintenance issue category',
    DELETE_ORGANIZATION: 'Delete organization',
    DELETE_ORGANIZATION_TYPE: 'Delete organization type',
    DELETE_PASSENGER_FLOW: 'Delete customer flow',
    DELETE_PERSON: 'Delete staff',
    DELETE_PURCHASE_HISTORY: 'Delete purchase record',
    DELETE_QUESTION: 'Delete exam question',
    DELETE_QUESTION_BANK: 'Delete question bank',
    DELETE_QUESTION_BANK_QUESTIONS: 'Delete question bank questions',
    DELETE_QUESTION2: 'Delete question bank questions',
    DELETE_QUESTION1: 'Delete question',
    DELETE_RECORD: 'Delete record',
    DELETE_REGION: 'Delete location',
    DELETE_REPORT_FIELD_ON_DATA: 'Delete report data customize field',
    DELETE_ROLE: 'Delete role',
    DELETE_SALES_DATA: 'Delete sales data',
    DELETE_STORE: 'Delete store',
    DELETE_STORE_ATTACHMENTS: 'Delete store attachment',
    DELETE_STORE_CAMERA: 'Delete store camera',
    DELETE_STORE_TYPE: 'Delete store type',
    DELETE_TASK_TYPE: 'Delete task type',
    DELETE_TEMPLATE: 'Delete template',
    DELETE_TEST_PAPER: 'Delete exam paper',
    DELETE_THE_REPORT_ON_THE_DATA: 'Delete report data',
    DELETE_THIS_CATEGORY: 'Delete daily log category',
    DELETE_THIS_FAILED_POST: 'Delete daily log post failed',
    DELETE_THIS_POST: 'Delete daily log post',
    DELETE_TRAINING_MATERIALS: 'Delete training information',
    DELETE_TRANSFER_BOOK: 'Delete daily log',
    DELETE_USER_REFERENCE: 'Delete user reference',
    DELETE_VISUAL_DISPLAY_ITEM_DETAILS: 'Delete VM project detail',
    DELETE_VISUAL_DISPLAY_ITEMS: 'Delete VM project',
    DELETION_FAILED_BECAUSE_A_ROLE_IN_THIS_ROLE_IS_ALREADY_USED: 'Delete failed - This role has been taken in a position',
    DELETION_FAILED_DELETE_TYPE_ALREADY_USED_IN_TYPE: 'Delete failed - Type is in used',
    DELETION_FAILED_ITEM_WITH_CHILD_MEMBERS_IN_OPTION: 'Delete failed - Child member exists in this selection.',
    DELETION_FAILED_ITEMS_USED_IN_ASSET_CONFIGURATION_SETTINGS_EXIST_IN_OPTIONS: 'Delete failed - This asset setting are in used.',
    DELETION_FAILED_ITEMS_USED_IN_ITEM_INFORMATION_MANAGEMENT_EXIST_IN_OPTIONS: 'Delete failed - The prop information management is in used.',
    DELETION_FAILED_SOMEONE_IN_THE_POST: 'Delete failed - This position is in used.',
    DELETION_FAILED_SOMEONE_IS_ALREADY_SERVING: 'Delete failed - Staff is holding this position',
    DELETION_FAILED_THE_ASSET_NAME_USED_IN_THE_STORE_EXISTS_IN_THE_SELECTION: 'Delete failed - Asset name selected is in used in the store.',
    DELETION_FAILED_WITH_ITEMS_USED_IN_MAINTENANCE_INFORMATION_MANAGEMENT_IN_OPTIONS: 'Delete failed - Maintenance information management selected is in used.',
    DELETION_FAILED_YOU_CANNOT_DELETE_THE_ADJUSTMENT_FACTOR_LESS_THAN_OR_EQUAL_TO_TODAY: 'Delete failed - Cannot delete adjustment factor that lesser or equal to today.',
    DELETION_OF_PERSONNEL_ASSESSMENT_TEMPLATE: 'Delete staff assessment question template',
    DESCRIPTION: 'Description',
    DESCRIPTION1: 'Description',
    DETAILS: 'Details',
    DETAILS_AND_COMMENTS: 'Details & comments',
    DETERMINE: 'Confirm',
    DEVIATION: 'Discrepancy',
    DEVICE_CODE: 'Device code',
    DEVICE_DESCRIPTION: 'Device description',
    DEVICE_MAC_ADDRESS: 'Device MAC address',
    DEVICE_NAME: 'Device name',
    DIRECTORY: 'Directory',
    DISABLE: 'Disable',
    DISCOUNT_FACTOR: 'Discount factor',
    DISPLAY_BROCHURE: 'VM manual',
    DISPLAY_BROCHURE_CONFIGURATION_TEMPLATE: 'VM manual configurations',
    DISPLAY_BROCHURE_TEMPLATE: 'VM manual template',
    DISPLAY_ELEMENT: 'Display element',
    DISPLAY_ITEM_NAME: 'VM project name',
    DISPLAY_PROPS: 'Display props',
    DISPLAY_THEME: 'VM theme',
    DOCUMENT: 'Document',
    DOCUMENT_LIST: 'Document list',
    DOCUMENT_NUMBER: 'Document code',
    DOCUMENT_TYPE: 'Document type',
    DOWNLOAD_COMPETITIVE_INFORMATION_TEMPLATE: 'Download competing product information template',
    DOWNLOAD_COMPETITIVE_PRODUCT_CLASSIFICATION_TEMPLATE: 'Download competing product category template',
    DOWNLOAD_ENTERPRISE_REPAIR_CODE: 'Download  maintenance code',
    DOWNLOAD_FAILED: 'Download failed',
    DOWNLOAD_FEEDBACK_FORM: 'Download feedback form',
    DOWNLOAD_IMPORT_TEMPLATE: 'Download import template',
    DOWNLOAD_INVENTORY_TEMPLATE: 'Download inventory template',
    DOWNLOAD_LINK: 'Download link',
    DOWNLOAD_PRODUCT_CLASSIFICATION_TEMPLATE: 'Download product category template',
    DOWNLOAD_PRODUCT_INFORMATION_TEMPLATE: 'Download product information template',
    DOWNLOAD_PROP_CLASSIFICATION_TEMPLATE: 'Download prop category template',
    DOWNLOAD_PROP_TEMPLATE: 'Download prop template',
    DOWNLOAD_REPAIR_CLASSIFICATION_TEMPLATE: 'Download maintenance category template',
    DOWNLOAD_REPAIR_FAILURE_TEMPLATE: 'Download maintenance template',
    DOWNLOAD_SHOP_REPAIR_CODE: 'Download store maintenance code',
    DOWNLOAD_STORE_PROPS_TEMPLATE: 'Download store prop template',
    DOWNLOAD_SUCCESSFUL: 'Downloaded successfully',
    DOWNLOAD_TEMPLATE: 'Download template',
    DROP_DOWN_BOX_FOR_ALL_OPTIONAL_LABELS: 'Drop down for all available tags',
    DUPLICATE_CATEGORY_NAMES_IN_EXCEL_ARE_DUPLICATED: 'Duplicate competing product category in Excel;',
    DUPLICATE_NAMES: 'Duplicate name;',
    DUPLICATE_ORGANIZATION_NAMES_IN_EXCEL: 'Duplicate organization name in Excel;',
    worker_common_000008: 'Duplicate organization name in Excel;',
    DUPLICATE_PRODUCT_NAME: 'Duplicate product name',
    DUPLICATE_PRODUCT_NAMES_IN_EXCEL: 'Duplicate product name in Excel;',
    DUPLICATE_THE_SAME_SHOP_NAME_IN_EXCEL: 'Duplicate store name in Excel;',
    DUPLICATE_THE_SAME_SHOP_NUMBER_IN_EXCEL: 'Duplicate store code in Excel;',
    DUPLICATE_USER_PHONE_NUMBER_IN_EXCEL: 'Duplicate user mobile number in Excel;',
    DUPLICATION_OF_GOODS_UNDER_THE_ORGANIZATION: 'Duplicate product under organization',
    EASY_KNOW_CODE: 'Easy Learning code',
    EASY_TO_KNOW_CONFIGURATION: 'Easy Learning configurations',
    EASY_TO_KNOW_URL: 'Easy Learning URL',
    EASY_TO_KNOW_WEBSITE_CODE: 'Easy Learning website code',
    EDIT_BRAND: 'Modify brand',
    EDIT_BRAND_TYPE: 'Modify brand type',
    EDIT_DETAILS: 'Modify details',
    EDIT_FAILED_THE_SAME_ORGANIZATION_OR_SHOP_NAME_ALREADY_EXISTS: 'Modify failed -  Same organization or store name exists.',
    EDIT_POSITION: 'Modify position',
    EDIT_POST_FAILED: 'Modify position failed',
    EDIT_REGION: 'Modify location',
    EDIT_SHOP: 'Modify store',
    EDITING_OPTIONS: 'Modify',
    EDITING_TAGS: 'Edit Tag',
    EFFECTIVE: 'Valid',
    EFFECTIVE_DATE: 'Effective date',
    EMPLOYEE_SUPERIOR: 'Superior',
    EMPTY_ORGANIZATION_SHOP: 'Empty organization store',
    ENABLE: 'Enable',
    ENCODING_CANNOT_BE_EMPTY: 'Code cannot be empty',
    END_DATE: 'Completed date',
    END_DATE_CANNOT_BE_LESS_THAN_START_DATE: 'Completed date cannot be less than start date',
    END_TIME: 'End time',
    END_TIME1: 'End Date',
    ENDING_NUMBER: 'End quantity',
    ENGINEERING_MANAGEMENT: 'Engineering Management',
    m_info_common_000018: 'Engineering Management',
    ENGLISH: 'English',
    ENGLISH_NAME: 'Name',
    ENTER_1: 'Enter 1',
    ENTER_2: 'Enter 2',
    ENTER_3: 'Enter 3',
    ENTER_4: 'Enter 4',
    ENTER_5: 'Enter 5',
    ENTERPRISE: 'Enterprise',
    ENTERPRISE_ANNOUNCEMENT: 'Enterprise announcement',
    ENTERPRISE_REPAIR_CODE_GENERATION_FAILED: 'Generating enterprise maintenance code failed',
    ENTERPRISE_SHARING: 'Enterprise sharing',
    m_info_common_000035: 'Enterprise sharing',
    ENTRIES_FAIL_TO_SUBMIT_QUESTIONS: 'You need to submit question when entries failed',
    ENTRY_CATEGORY_CANNOT_BE_EMPTY: 'Entry category cannot be empty;',
    ENTRY_NAME: 'Entry name',
    ENTRY_NAME_CANNOT_BE_EMPTY: 'Entry name cannot empty',
    ENTRY_NUMBER: 'Entry number',
    EQUIPMENT_MODEL: 'Device model',
    EQUIPMENT_QUANTITY: 'Device quantity',
    EQUIPMENT_TYPE: 'Device type',
    ERROR_WRITING_FILE_TO_HARD_DISK: 'Disk write error',
    EXAM_ID: 'Exam ID',
    EXAM_ID1: 'Exam ID',
    EXAM_INFORMATION: 'Exam information',
    EXAM_LIST: 'Exam list',
    EXAM_NOTES: 'Exam paper remarks',
    EXAM_NOTES1: 'Exam notes',
    EXAMINATION_TIME: 'Examination time',
    EXAMINER: 'Candidate',
    EXCEED: 'Exceed (',
    EXCEEDS_THE_SIZE_ALLOWED_BY_THE_FORM: 'Exceeded the size limit allow by system',
    EXCEL_EXPORT: 'Export to Excel',
    EXCEPT_FOR_ARCHIVED_DATA_OTHER_DATA_HAS_BEEN_DELETED_NORMALLY: 'Except archiving data, other data has been deleted',
    EXCHANGE_RATE_MANAGEMENT: 'Exchange rate management',
    EXCHANGE_RATE_SETTING: 'Exchange rate settings',
    EXPAND: 'Expand',
    EXPIRATION_DATE: 'Validity period',
    ExcelTemplate_common_000019: 'Validity period',
    EXPLANATION_OR_NOTE: 'Remarks',
    EXPORT_COMPETING_CATEGORIES: 'Export competing product categories',
    EXPORT_COMPETITION: 'Export competing product',
    EXPORT_DATA: 'Export selected data',
    EXPORT_DATA_UNDER_THE_CURRENT_QUERY_CONDITIONS: 'Export data under current search conditions',
    EXPORT_DISPLAY_BROCHURE: 'Export VM manual',
    EXPORT_EXCEL: 'Export to Excel',
    EXPORT_FAILED: 'Export failed!',
    EXPORT_INSPECTION_TOUR: 'Export checklist',
    EXPORT_MULTIPLE_LANGUAGES: 'Export multi-language',
    EXPORT_PEOPLE_EXCEL: 'Export staff to Excel',
    EXPORT_PREVIEW: 'Export preview',
    EXPORT_PRODUCT: 'Export product',
    EXPORT_PRODUCT_CATEGORIES: 'Export product category',
    EXPORT_PROP_CLASSIFICATION: 'Export prop category',
    EXPORT_PROPS: 'Export',
    EXPORT_RETAIL_TOUR: 'Export checklist',
    EXPORT_STAFF_TO_EXCEL: 'Export job to Excel',
    EXTENDED_FIELD_01: 'Extended field 01',
    EXTENDED_FIELD_02: 'Extended field 02',
    EXTENDED_FIELD_03: 'Extended field 03',
    EXTENDED_FIELD_04: 'Extended field 04',
    EXTENDED_FIELD_05: 'Extended field 05',
    EXTENDED_FIELD_06: 'Extended field 06',
    EXTENDED_FIELD_07: 'Extended field 07',
    EXTENDED_FIELD_08: 'Extended field 08',
    EXTENDED_FIELD_09: 'Extended field 09',
    EXTENDED_FIELD_10: 'Extended field 10',
    EXTENDED_FIELD_11: 'Extended field 11',
    EXTENDED_FIELD_12: 'Extended field 12',
    EXTENDED_FIELD_13: 'Extended field 13',
    EXTENDED_FIELD_14: 'Extended field 14',
    EXTENDED_FIELD_15: 'Extended field 15',
    EXTENDED_FIELD_16: 'Extended field 16',
    EXTENDED_FIELD_17: 'Extended field 17',
    EXTENDED_FIELD_18: 'Extended field 18',
    EXTENDED_FIELD_19: 'Extended field 19',
    EXTENDED_FIELD_20: 'Extended field 20',
    FAIL_TO_EDIT: 'Edit failed',
    FAIL_TO_EDIT1: 'Edit failed',
    FAIL_TO_EDIT2: 'Modify failed',
    FAILED_THE_TEMPLATE_NAME_ALREADY_EXISTS: 'Failed: template name already exists',
    FAILED_TO_ADD_A_QUESTION_BANK_QUESTION: 'Add question failed',
    FAILED_TO_ADD_BRAND_TYPE: 'Add brand type failed',
    FAILED_TO_ADD_ITEM_CATEGORY: 'Add prop category failed',
    FAILED_TO_ADD_JOB: 'Add position failed',
    FAILED_TO_ADD_ORGANIZATION_LEVEL_HAS_REACHED_THE_UPPER_LIMIT: 'Add failed - organization level has reached maximum limit',
    FAILED_TO_ADD_OTHER_ADJUSTMENT_FACTORS_EXIST_IN_THE_STARTTOEND_TIME_PERIOD: 'Add failed - other adjustment factor exist between start and end time',
    FAILED_TO_ADD_PRODUCT_CATEGORY: 'Add product category failed',
    FAILED_TO_ADD_REGION: 'Add location failed',
    FAILED_TO_ADD_ROLE: 'Add role failed',
    FAILED_TO_ADD_ROLE1: 'Add role failed,',
    FAILED_TO_ADD_SALES_DATA: 'Add sales data failed',
    FAILED_TO_ADD_STORE_TYPE: 'Add store type failed',
    FAILED_TO_ADD_TASK_TYPE: 'Add task type failed',
    FAILED_TO_ADD_THE_PROBLEM_DESCRIPTION_DOES_NOT_EXCEED_1000_WORDS: 'Add failed - problem description must not exceed 1000 words',
    FAILED_TO_ADD_THE_TRANSFER_LABEL: 'Add daily log tag failed',
    FAILED_TO_DELETE: 'Delete failed!',
    FAILED_TO_DELETE_BRAND_TYPE: 'Delete brand type failed',
    FAILED_TO_DELETE_CANNOT_DELETE_THE_STORE: 'Delete failed - Cannot delete store',
    FAILED_TO_DELETE_COMMON_DATA: 'Delete general data failed',
    FAILED_TO_DELETE_CUSTOM_FIELD: 'Delete custom field failed',
    FAILED_TO_DELETE_DEALER_TYPE: 'Delete vendor type failed',
    FAILED_TO_DELETE_DEFECTIVE_PARTS: 'Delete defective accessories failed',
    FAILED_TO_DELETE_DEFECTIVE_PRODUCT: 'Delete defective problem failed',
    FAILED_TO_DELETE_DEFECTIVE_PRODUCT_CLASSIFICATION: 'Delete defective problem category failed',
    FAILED_TO_DELETE_DOCUMENT: 'Delete document failed',
    FAILED_TO_DELETE_FILE_TYPE: 'Failed to delete file type',
    FAILED_TO_DELETE_JOB: 'Delete position failed',
    FAILED_TO_DELETE_MAINTENANCE_ISSUE: 'Delete maintenance issue failed',
    FAILED_TO_DELETE_MAINTENANCE_PROBLEM_CLASSIFICATION: 'Delete maintenance issue category failed',
    FAILED_TO_DELETE_PERSON: 'Delete staff failed',
    FAILED_TO_DELETE_PURCHASE_RECORD: 'Delete purchase record failed',
    FAILED_TO_DELETE_REGION: 'Delete location failed',
    FAILED_TO_DELETE_ROLE: 'Delete role failed',
    FAILED_TO_DELETE_STORE: 'Delete store failed',
    FAILED_TO_DELETE_STORE_ATTACHMENT: 'Delete store attachment failed',
    FAILED_TO_DELETE_STORE_TYPE: 'Delete store type failed',
    FAILED_TO_DELETE_STORE_VENDOR: 'Delete store vendor failed',
    FAILED_TO_DELETE_TASK_TYPE: 'Delete task type failed',
    FAILED_TO_DELETE_THE_STORE_CAMERA: 'Delete store camera failed',
    FAILED_TO_DELETE_THE_TRANSFER_BOOK: 'Delete daily log failed',
    FAILED_TO_DELETE_THERE_ARE_ITEMS_USED_IN_THE_ORGANIZATION_NODE_DETAILS_IN_THE_DELETED_ITEMS: 'Delete failed - Organization node details is in used',
    FAILED_TO_DELETE_THERE_ARE_ITEMS_USED_IN_THE_ORGANIZATIONAL_STRUCTURE_SETTING_IN_THE_DELETED_ITEMS: 'Delete failed - Organization structure settings are in used',
    FAILED_TO_DELETE_THERE_IS_AN_ITEM_USED_IN_THE_ROLE_SETTING_IN_THE_DELETED_ITEM: 'Delete failed - Role settings are in used',
    FAILED_TO_DELETE_THIS_CATEGORY: 'Delete daily log category failed',
    FAILED_TO_DELETE_TRACKING: 'Delete item tracking failed',
    FAILED_TO_DELETE_USER_REFERENCE: 'Delete user reference failed',
    FAILED_TO_DELETE_VENDOR_TYPE: 'Delete vendor type failed',
    FAILED_TO_DELETE_VISUAL_DISPLAY_ITEM: 'Delete VM project failed',
    FAILED_TO_DELETE_VISUAL_DISPLAY_ITEM_DETAILS: 'Delete VM project detail failed',
    FAILED_TO_DELETE1: 'Delete failed:',
    FAILED_TO_DELETE2: 'Delete failed',
    FAILED_TO_GET_THE_FILE_CORRESPONDING_TO_THIS_ID_PLEASE_CONTACT_THE_ADMINISTRATOR: 'Failed to get the file corresponding to this ID. Please contact your administrator.',
    FAILED_TO_LOAD: 'Loading failed',
    FAILED_TO_MODIFY_BRAND: 'Modify brand failed',
    FAILED_TO_MODIFY_BRAND_TYPE: 'Modify brand type failed',
    FAILED_TO_MODIFY_COMPETITION_CATEGORY: 'Modify competing product  brand failed',
    FAILED_TO_MODIFY_CUSTOM_FIELDS: 'Modify custom field failed',
    FAILED_TO_MODIFY_DEFECTIVE_PARTS: 'Modify defective accessories failed',
    FAILED_TO_MODIFY_DEFECTIVE_PRODUCT: 'Modify defective product problem failed',
    FAILED_TO_MODIFY_FORM_PERMISSIONS: 'Modify form permission failed',
    FAILED_TO_MODIFY_GENERAL_DATA: 'Modify general data failed',
    MODIFYING_GENERAL_DATA_FAILED: 'Modify general data failed',
    FAILED_TO_MODIFY_ITEM_CATEGORY: 'Modify prop category failed',
    FAILED_TO_MODIFY_MAINTENANCE_ISSUES: 'Modify maintenance issue failed',
    FAILED_TO_MODIFY_PRODUCT_CATEGORY: 'Modify product category failed',
    FAILED_TO_MODIFY_PURCHASE_RECORD: 'Modify purchase record failed',
    FAILED_TO_MODIFY_ROLE: 'Modify role failed',
    FAILED_TO_MODIFY_ROLE_PERMISSIONS: 'Modify role permission failed',
    FAILED_TO_MODIFY_SALES_DATA: 'Modify transaction data failed',
    FAILED_TO_MODIFY_STORE: 'Modify store failed',
    FAILED_TO_MODIFY_STORE_CAMERA: 'Modify store camera failed',
    FAILED_TO_MODIFY_STORE_EQUIPMENT: 'Modify store device failed',
    FAILED_TO_MODIFY_STORE_TYPE: 'Modify store type failed',
    FAILED_TO_MODIFY_TASK_TYPE: 'Modify task type failed',
    FAILED_TO_MODIFY_THE_CLASSIFICATION_OF_DEFECTIVE_PRODUCTS: 'Modify defective product problem category failed',
    FAILED_TO_MODIFY_THE_PHONE_NUMBER_IS_ALREADY_USED: 'Modify failed - This mobile number has already been used.',
    FAILED_TO_MODIFY_THE_TRANSFER_OF_THIS_LABEL: 'Modify daily log tag failed',
    FAILED_TO_RESET_PASSWORD: 'Password reset failed',
    FAILURE: 'Failed',
    FAILURE_ONLY_BMP__JPG__JPEG__PNG_FORMAT_PHOTOS_ARE_CURRENTLY_SUPPORTED: 'Failed: Only BMP / JPG / JPEG / PNG format photos are currently supported',
    FAILURE_TO_ADD_MAINTENANCE_PROBLEM_CLASSIFICATION: 'Add maintenance issue category failed',
    FAILURE_TO_MODIFY_MAINTENANCE_PROBLEM_CLASSIFICATION: 'Modify maintenance issue category failed',
    FAILURE1: 'Failed:',
    FEATURES_ARE_NOT_OPEN_YET: '　　Function not available yet',
    FEMALE: 'Female',
    infoapi_common_000022: 'Female',
    FIELD_NAME: 'Field name',
    FIELD_NOTES: 'Field remark',
    FIELD_NUMBER: 'Field code',
    FILE: 'File',
    FILE_CATEGORY: 'File category',
    FILE_EXTENSION: 'File extension',
    FILE_EXTENSION_CANNOT_BE_EMPTY: 'File extension cannot empty',
    FILE_FORMAT_ERROR_UPLOAD_FAILED: 'Upload failed due to incorrect file format.',
    FILE_LINK_WILL_BE_DISPLAYED_AFTER_SAVING: 'File link will be displayed after saving',
    FILE_NAME: 'Document name',
    FILE_NAME_CANNOT_BE_EMPTY: 'File name cannot empty',
    FILE_NAME1: 'File name:',
    FILE_NAME2: 'File name',
    FILE_SIZE: 'File size',
    FILE_TITLE: 'File title',
    FILE_TITLE_CANNOT_BE_EMPTY: 'File title cannot empty',
    FILE_TYPE: 'File type',
    FILE_TYPE_INFORMATION: 'File type information',
    FILE_TYPE_NAME: 'File type name',
    FILE_UPLOAD_FAILED: 'File upload failed',
    FILTER_ROLES: 'Filter roles',
    FIND: 'Find',
    FIRST_WEEK_OF_EACH_YEAR: 'First week of each year',
    FIX_DEFECTIVE_PRODUCTS: 'Modify defective problem',
    FIX_MAINTENANCE_ISSUES: 'Modify maintenance issue',
    FIXED_PASSWORD: 'Fixed password',
    FIXED_PASSWORD_CANNOT_BE_EMPTY: 'Fixed password cannot empty',
    FLOOR_PLAN_FILE_ID_FORMAT_ERROR: 'Floor plan file ID format error;',
    FLOOR_PLAN_TITLE_CANNOT_BE_EMPTY: 'Floor plan title cannot be empty;',
    FOLDER__FILE: 'Folder/ file',
    FOR_GROUP_MESSAGING_YOU_MUST_SELECT_AN_ORGANIZATION: 'Broadcast message, you must choose an organization.',
    FORCED_DISPLAY_OF_TOTAL_SCORE: 'Force to display total score',
    FORMAT: 'Format',
    FORWARD_NEWS: 'Forward message',
    FOUNDER: 'Created by',
    FREEZE: 'Freeze',
    FREEZE_SUCCESSFULLY: 'Freeze successfully',
    FRIDAY: 'Friday',
    FROZEN: 'Frozen',
    FULL_MARK_SETTING: 'Full score setting',
    FULL_VALUE: 'Full score',
    GENDER: 'Gender',
    ExcelTemplate_common_000017: 'Gender',
    GENERAL_COMMENT: 'Overall Rating',
    GENERAL_DATA_DICTIONARY: 'General data dictionary',
    GENERAL_DATA_INFORMATION: 'General information',
    GENERAL_USER: 'Normal user',
    GENERATE_ENTERPRISE_REPAIR_SPECIALIST: 'Generate enterprise maintenance specialist',
    GENERATE_REPAIR_CODE: 'Generate maintenance code',
    GENERATED_SUCCESSFULLY: 'Generated successfully',
    GENERATION_OF_MAINTENANCE_CODE_SOME_SELECTED_SHOPS_DO_NOT_HAVE_A_SHOP_NUMBER_AND_CANNOT_GENERATE_REPAIR_CODES: 'Maintenance code is generating. Some selected store do not have store code, unable to generate Maintenance code.',
    GET_VERIFICATION_CODE: 'Get verification code',
    GOODS_TRACKING: 'Item tracking',
    m_info_common_000006: 'Item Tracking',
    GREETING_RETURN_VISIT_TEMPLATE: 'Return visit template',
    GREETINGS_RETURN_VISIT_DATA_IMPORT: 'Import return visit data',
    HAND_HELD_MACHINE: 'Mobile phone',
    HAND_OVER_THIS: 'Daily log',
    m_info_common_000029: 'Daily Log',
    HAVE: 'Have',
    HAVE_READ: 'Have you read?',
    HIDDEN_DAYS: 'Hide days',
    HIDE_SCORE: 'Hide score',
    HIGH_STRENGTH: 'High strength',
    HISTORICAL_EXCHANGE_RATE_SETTINGS: 'Historical exchange rate setting',
    HOBBY: 'Hobby',
    HOUR: 'Hour',
    IDENTIFY: 'Identify',
    IF_THE_SIGN_USER_AGREEMENT_OPTION_IS_CHECKED_THE_USER_AGREEMENT_FILE_MUST_BE_UPLOADED: 'If the sign user agreement option is checked, the user agreement file must be uploaded',
    IF_YOU_MODIFY_THE_TEMPLATE_ALL_UNSUBMITTED_TEMPLATES_WILL_NEED_TO_BE_REEDITED_ARE_YOU_SURE_YOU_WANT_TO_MODIFY_IT: 'If you modify the template, all unsubmitted templates will need to be re-edited. Are you sure you want to modify?',
    IMAGE: 'Image',
    IMAGES_WERE_ONLY_PARTIALLY_UPLOADED: 'Image was uploaded partially',
    IMPORT: 'Import',
    IMPORT_AREA: 'Import location',
    IMPORT_ASSISTANT: 'Import assistant',
    IMPORT_BASIC_DATA: 'Import basic data',
    IMPORT_BRAND: 'Import brand',
    IMPORT_COMPETING_CATEGORIES: 'Import competing product categories',
    IMPORT_COMPETITION_INFORMATION: 'Import competing product information',
    IMPORT_CUSTOMER: 'Import customer',
    IMPORT_DATA: 'Import data',
    IMPORT_DEALER: 'Import vendor',
    IMPORT_DISPLAY_BROCHURE: 'Import manual',
    IMPORT_DISPLAY_BROCHURE_CONFIGURATION: 'Import manual configurations',
    IMPORT_DISPLAY_BROCHURE_RELATIONSHIP: 'Import VM manual relationship',
    IMPORT_EXCEL: 'Import Excel',
    IMPORT_FAILED: 'Import failed:',
    IMPORT_FILE_NAME: 'Import file name',
    IMPORT_FILE_SIZE_CANNOT_EXCEED: 'Import file size cannot exceed',
    IMPORT_GOODS: 'Import inventory',
    IMPORT_GREETING_RETURN_VISIT: 'Import return visit',
    IMPORT_INSPECTION_TOUR: 'Import checklist',
    IMPORT_INVENTORY: 'Import inventory',
    IMPORT_ITEM_CLASSIFICATION: 'Import prop category',
    IMPORT_MAINTENANCE_CLASSIFICATION: 'Import maintenance category',
    IMPORT_MAINTENANCE_FAILURE: 'Import maintenance issue',
    IMPORT_ORGANIZATION: 'Import organization',
    IMPORT_PASSENGER_FLOW_CHANNEL: 'Import customer flow template',
    IMPORT_PRODUCT_CATEGORIES: 'Import product category',
    IMPORT_PRODUCT_INFORMATION: 'Import product information',
    IMPORT_PROFESSIONAL_STORE_WITH_SHOP_TEMPLATE: 'Import store project template',
    IMPORT_PROGRESS: 'Import progress',
    IMPORT_PROPS: 'Import',
    IMPORT_PURCHASE_RECORDS: 'Import purchase record',
    IMPORT_ROLES: 'Import role',
    IMPORT_SALES: 'Import sales',
    IMPORT_SHOP: 'Import store',
    IMPORT_SHOP_EQUIPMENT: 'Import store device',
    IMPORT_SHOP_ITEMS: 'Import store prop',
    IMPORT_STAFF: 'Import job',
    IMPORT_STAFF_ASSESSMENT_TEMPLATE: 'Import staff assessment template',
    IMPORT_STATUS: 'Import status',
    IMPORT_SUCCEEDED: 'Imported successfully',
    IMPORT_SUPPLIER: 'Import vendor',
    IMPORT_TIME: 'Import time',
    IMPORT_TYPE: 'Import type',
    IMPORTER: 'Import staff',
    INBOUND_TRAFFIC: 'Import customer flow',
    INCORRECT_DATA: 'Data error',
    INCORRECT_TIME_FORMAT: 'Incorrect time format',
    INCORRECT_TIME_RANGE: 'Incorrect time range',
    INCORRECT_USERNAME_OR_VERIFICATION_CODE: 'Incorrect username or verification code',
    INDEX: 'Index',
    INDUSTRY: 'Industry',
    INFORMATION: 'Information',
    INPUT_VALUE_TYPES_DO_NOT_MATCH: 'Input value types do not match;',
    INQUIRE: 'Search',
    INSERT_PICTURE: 'Insert image',
    INTERNAL_ERROR_DO_YOU_DOWNLOAD_AND_VIEW_THE_PROMPT_FILE: 'Internal error, download and view the log file?',
    INTERNAL_ERROR_PLEASE_VERIFY: 'Internal error, please verify',
    INVALID_ATTACHMENT_ID_FORMAT: 'Invalid attachment ID format',
    INVALID_DATE_FORMAT: 'Invalid date format',
    INVALID_ID: 'Invalid ID',
    INVALID_MANUAL_ID_FORMAT: 'Invalid manual ID format',
    INVALID_NAME: 'Invalid name;',
    INVALID_NUMBER: 'Invalid code',
    INVALID_OPERATION_NO_JOBS_IN_THIS_AREA: 'Invalid operation, this location do not have position.',
    INVALID_OPERATION_THIS_ROLE_HAS_NO_REGION_SELECTION: 'Invalid operation, this role does not have location selection.',
    INVALID_ORGANIZATION: 'Invalid organization;',
    INVALID_PRIMARY_KEY_ID_FORMAT: 'Invalid primary key ID format',
    INVALID_PRODUCT: 'Invalid product;',
    INVALID_SERVICE_CODE: 'Invalid service code',
    INVALID_STORE_ID_FORMAT: 'Invalid store ID format',
    INVALID_SUPERIOR: 'Invalid superior',
    INVENTORY_DATA_IMPORT: 'Import inventory data',
    IP_ADDRESS: 'IP address',
    IS_REQUIRED: 'Is it required?',
    ISSUE_CATEGORY_INFORMATION_EDIT: 'Modify question category information',
    ISSUE_INFORMATION_EDITING: 'Modify question information',
    ISSUE_NUMBER: 'Issue Quantity',
    ISSUE_NUMBER1: 'Question number',
    ITEM_CATEGORY: 'Props category',
    ITEM_CATEGORY_INFORMATION: 'Prop category information',
    ITEM_CATEGORY_SETTINGS: 'Props category setting',
    ITEM_CLASSIFICATION: 'Props category',
    ITEM_CLASSIFICATION_DOES_NOT_EXIST: 'Props category do not exist',
    ITEM_CLASSIFICATION_IMPORT: 'Import props category',
    ITEM_CODE_CANNOT_BE_EMPTY: 'Props code cannot be empty;',
    ITEM_CODES_CANNOT_BE_REPEATED_UNDER_THE_SAME_ITEM_CATEGORY: 'Prop codes cannot be duplicated under the same prop category;',
    ITEM_CORRESPONDING_SUPPLIER_DOES_NOT_EXIST: 'Vendor corresponding to the props does not exist',
    ITEM_DESCRIPTION: 'Entry description',
    ITEM_INFORMATION: 'Props information',
    ITEM_INFORMATION_MANAGEMENT: 'Props information management',
    ITEM_NAME: 'Props Name',
    ITEM_NAME_CANNOT_BE_EMPTY: 'Probs Name field is required',
    ITEM_NAMES_CANNOT_BE_DUPLICATED_UNDER_THE_SAME_ITEM_CATEGORY: 'Prop names cannot be duplicated under the same prop category;',
    ITEM_NUMBER: 'Props code',
    ITEM_NUMBER_DOES_NOT_EXIST: 'Props code do not exist',
    ITEM_REPAIR: 'Props maintenance',
    ITEM_UNITS_CANNOT_BE_EMPTY: 'Props unit cannot be empty',
    JAPANESE: 'Japanese',
    JOB_DETAILS: 'Position description',
    JOB_INFORMATION: 'Position information',
    JOB_INFORMATION1: 'Position information',
    JOB_SHOP_PROJECT_MANAGEMENT: 'Store project management',
    m_info_common_000009: 'Store project management',
    JOB_SHOP_TEMPLATE: 'Store duty template',
    JOB_TITLE: 'Position name',
    JOB_TITLE1: 'Position name:',
    KEYWORD_SEARCH: 'Search',
    KOREAN: 'Korean',
    KPI_MANAGEMENT: 'KPI Mgmt.',
    m_info_common_000015: 'KPI Mgmt.',
    LABEL: 'Tag',
    LABEL_1: 'Tag 1',
    LABEL_2: 'Tag 2',
    LABEL_3: 'Tag 3',
    LABEL_INFORMATION: 'Tag information',
    LABEL_NAME: 'Tag name',
    LANGUAGE_SELECTION: 'Language selection',
    LAST_LOGIN_TIME: 'Last login time',
    LAST_NAME: 'Last name',
    LAST_RENOVATION_TIME: 'Last renovation time',
    LAST_UPDATE_TIME: 'Last update time',
    LAST_UPDATED: 'Last Updated',
    LAST_UPDATED_BY: 'Last updated by',
    LEARNER: 'Learner',
    LEARNING_RECORD: 'Learning record',
    LEAVE_BLANK: 'Leave blank',
    LIMIT: 'Limit',
    LIMIT_SET_THE_MAXSIZE_PROPERTY_TO_CHANGE_THE_LIMIT: 'Limit! Set the MaxSize to change the limit!',
    LINK_ADDRESS: 'Address link',
    LINKED: 'Associated',
    LIST_OF_CONTROLS: 'List of controls',
    LIST_OF_SHOPS: 'Store list',
    LOADING: 'Loading',
    LOCALE: 'Location setup',
    LOCATION_INFORMATION_EDITING: 'Modify location information',
    LOCKING: 'Lock',
    LOG_IN: 'Log in',
    LOGIN_PROTECTION: 'Login protection',
    LOGIN_TO_THE_INFORMATION_MANAGEMENT_PLATFORM: 'Logged in to the information management platform',
    LONG_TERM_EFFECTIVE: 'Always valid',
    LOVE: 'Hobby',
    LUMP_SUM: 'Total amount',
    M: 'Customer category',
    MAIL_BOX: 'Email',
    MAIL_CONFIGURATION: 'Email configurations',
    MAILBOX: 'Email',
    ExcelTemplate_common_000020: 'Email',
    MAIN_PICTURE: 'Main image?',
    MAINTENANCE_AUTHORITY: 'Maintenance permission',
    MAINTENANCE_AUTHORIZATION_MANAGEMENT: 'Maintenance authorization management',
    MAINTENANCE_CATEGORY_SETTING: 'Maintenance category settings',
    MAINTENANCE_CLASSIFICATION: 'Maintenance category',
    MAINTENANCE_CLASSIFICATION_IMPORT: 'Import maintenance data',
    MAINTENANCE_DATA_DICTIONARY: 'Maintenance data dictionary',
    MAINTENANCE_FAULT_CLASSIFICATION: 'Maintenance fault category',
    MAINTENANCE_FAULT_CLASSIFICATION_DOES_NOT_EXIST: 'Maintenance fault category does not exist',
    MAINTENANCE_FAULT_CLASSIFICATION_ENGLISH_NAME: 'Maintenance fault category name',
    MAINTENANCE_FAULT_CLASSIFICATION_INFORMATION: 'Maintenance fault category information',
    MAINTENANCE_FAULT_CLASSIFICATION_NAME: 'Maintenance fault category name',
    MAINTENANCE_FAULT_IMPORT: 'Import maintenance fault',
    MAINTENANCE_FAULT_NAME: 'Maintenance fault name',
    MAINTENANCE_INFORMATION_MANAGEMENT: 'Maintenance information management',
    MAINTENANCE_SUPPLIER_DATA_IMPORT: 'Import vendor maintenance data',
    MAJOR_CATEGORY_DOES_NOT_EXIST: 'Major category does not exist',
    MALE: 'Male',
    infoapi_common_000023: 'Male',
    MALFORMED_BIRTH_YEAR: 'Invalid birth year format',
    MANAGE_EXISTING_TAGS: 'Manage existing tags',
    MANUAL_UPLOAD_FILE_CANNOT_BE_LARGER_THAN_20M: 'Manual upload file cannot be larger than 20M',
    MANUAL_UPLOAD_FILE_CANNOT_BE_LARGER_THAN_40M: 'Manual upload file cannot be larger than 40M',
    MASS_SEND: 'Group send',
    MATTER_IS_WITHIN_THE_REQUIRED_DATE_RANGE: 'Issue in the days must within the date range',
    MATTER_MUST_BE_NUMERIC_ON_THE_FIRST_FEW_DAYS: 'Issue in the days must in numbers format',
    MATTERS_MUST_BE_GREATER_THAN_0_ON_THE_FIRST_FEW_DAYS: 'Issue in the days must greater than 0',
    MECHANISM_1_CONTAINS_THE_WEEK_OF_JANUARY_1: 'Mechanism 1: Include the week of 1st January',
    MECHANISM_2_WEEK_CONTAINING_1_FIRST_THURSDAY: 'Mechanism 2: Include the first Thursday week',
    MESSAGE_ADDED: 'Add message',
    MESSAGE_ADDITION_FAILED: 'Add message failed',
    MESSAGE_CENTER: 'Message centre',
    MESSAGE_CODE: 'Message code',
    MESSAGE_CONTENT: 'Message content',
    MESSAGE_DELETION: 'Message deleted',
    MESSAGE_NOTIFICATION: 'Message notification',
    MESSAGE_TYPE: 'Message type',
    MOBILE_PHONE: 'Mobile phone',
    MODE_OF_OPERATION: 'Business model',
    MODIFICATION_FAILED_BIRTH_TIME_CANNOT_EXCEED_CURRENT_TIME: 'Modify failed -  Birth time cannot exceed current time',
    MODIFICATION_FAILED_BUSINESS_START_TIME_CANNOT_BE_LESS_THAN_END_TIME: 'Modify failed -  Business start time must be greater than end time',
    MODIFICATION_FAILED_CANNOT_BE_MODIFIED_TO_AN_EXISTING_NONCUSTOM_ORGANIZATION: 'Modify failed -  Cannot modify existing non defined organization',
    MODIFICATION_FAILED_OTHER_ADJUSTMENT_FACTORS_EXIST_IN_THE_STARTTOEND_TIME_PERIOD: 'Modify failed -  Other adjustment factors exist between start and end time',
    MODIFICATION_OF_COMPETITION_CATEGORY_SUCCEEDED: 'Modified competing product category successfully',
    MODIFICATION_OF_RETAIL_TOUR_TEMPLATE: 'Modify checklist item template',
    MODIFY: 'Modify',
    MODIFY_ASSET_FAILED: 'Modify asset failed',
    MODIFY_ASSET_TYPE: 'Modify asset type',
    MODIFY_ASSET_TYPE_FAILED: 'Modify asset type failed',
    MODIFY_ASSETS: 'Modify assets',
    MODIFY_CLASSIFICATION: 'Modify category',
    MODIFY_COURSE: 'Modify course',
    MODIFY_COURSEWARE: 'Modify courseware',
    MODIFY_DEALER: 'Modify vendor',
    MODIFY_DEALER_TYPE: 'Modify vendor type',
    MODIFY_DEFECTIVE_PARTS: 'Modify defective parts',
    MODIFY_DISPLAY_MANUAL_AND_ROLE_ASSOCIATION: 'Modify VM manual and role association',
    MODIFY_FAILED_ILLEGAL_OPERATION: 'Modify failed -  Illegal operation',
    MODIFY_FAILED_NO_CORRECT_ANSWER_EXISTS_IN_OPTIONS: 'Modify failed -  No correct answer in the selection',
    MODIFY_FAILED_PHONE_NUMBER_ALREADY_EXISTS: 'Modify failed -  Mobile number does not exist',
    MODIFY_FAILED_START_TIME_CANNOT_BE_GREATER_THAN_END_TIME: 'Modify failed -  Start time cannot be greater than end time',
    MODIFY_FAILED_START_TIME_CANNOT_BE_LESS_THAN_TODAY: 'Modify failed -  Start time must be greater than today',
    MODIFY_FAILED_THE_NUMBER_OF_ORGANIZATIONS_IN_THE_ORGANIZATION_HAS_REACHED_THE_UPPER_LIMIT: 'Modify failed -  The number of organizations has reached its maximum limit',
    MODIFY_FILE_TYPE: 'Modify file type',
    MODIFY_FORM_PERMISSIONS: 'Modify form permission',
    MODIFY_GENERAL_DATA: 'Modify general data',
    MODIFY_GREETING_RETURN_VISIT_TYPE: 'Modify return visit type',
    MODIFY_ITEM_CATEGORY_SUCCESSFULLY: 'Modified prop category successfully',
    MODIFY_ITEM_CLASSIFICATION: 'Modify prop category',
    MODIFY_MAINTENANCE_PROBLEM_CLASSIFICATION: 'Modify maintenance issue category',
    MODIFY_MAINTENANCE_ROLE_PERMISSIONS: 'Modify maintenance role permissions',
    MODIFY_ORGANIZATION_NODE: 'Modify organization node',
    MODIFY_ORGANIZATION_TYPE: 'Modify organization type',
    MODIFY_PASSENGER_FLOW: 'Modify customer flow',
    MODIFY_PASSENGER_FLOW_CONVERSION_RATE: 'Modify customer flow conversion rate',
    MODIFY_PERSON: 'Modify staff',
    MODIFY_PERSONNEL_ASSESSMENT_TEMPLATE: 'Modify staff assessment template',
    MODIFY_PURCHASE_RECORDS: 'Modify purchase record',
    MODIFY_QUESTION_BANK_QUESTIONS: 'Modify question from question bank',
    MODIFY_REPORT_FIELD_ON_DATA: 'Modify data on report field:',
    MODIFY_RETAIL_TOUR_TEMPLATE: 'Modify checklist template',
    MODIFY_ROLE: 'Modify role',
    MODIFY_ROLE_PERMISSIONS: 'Modify role permission',
    MODIFY_SALES_DATA: 'Modify transaction data',
    MODIFY_SHOP_CAMERA: 'Modify store camera',
    MODIFY_SHOP_EQUIPMENT: 'Modify store device',
    MODIFY_STORE_TYPE: 'Modify store type',
    MODIFY_TASK_TYPE: 'Modify task type',
    MODIFY_TEST_PAPER: 'Modify exam paper',
    MODIFY_THE_ADJUSTMENT_FACTOR: 'Modify adjustment factors',
    MODIFY_THE_DEFECTIVE_PRODUCT_CLASSIFICATION: 'Modify defective problem category',
    MODIFY_THE_REPORT_ON_THE_DATA: 'Modify data on report field:',
    MODIFY_THE_RETAIL_TOUR_TEMPLATE_PROBLEM_CLASSIFICATION: 'Modify checklist item category template',
    MODIFY_THE_STAFF_ASSESSMENT_TEMPLATE: 'Modify staff assessment question template',
    MODIFY_THE_TEST_QUESTION: 'Modify exam paper question',
    MODIFY_THE_TRANSFER_LABEL: 'Modify daily log tag',
    MODIFY_USER_REFERENCE: 'Modify user reference',
    MODIFY_USER_REFERENCE_FAILED: 'Modify user reference failed',
    MODIFYING_CUSTOM_FIELDS: 'Modify custom field',
    MONEY_MANAGEMENT: 'Currency management',
    MONTH: 'Month',
    MORE_CONDITIONS: 'More conditions',
    MORE_THAN_1000_WORDS: 'The word count exceeds 1000 words;',
    MULTILINGUAL_SETTINGS: 'Multi-language settings',
    MULTILINGUAL_UPDATE_OF_MAINTENANCE_CLASSIFICATION: 'Multi-language update of maintenance category',
    MULTIPLE_CHOICE: 'Single Choice',
    SINGLE_CHOICE: 'Single Choice',
    z_info_common_000002: 'Single Choice',
    MULTIPLE_CHOICE_QUESTIONS: 'Multiple choice question',
    z_info_common_000003: 'Multiple choice questions',
    MUST_BE_THE_DEFAULT_LANGUAGE_WHEN_ADDING: 'Must be the default language when adding',
    NAME: 'Name',
    ExcelTemplate_common_000008: 'Name',
    NAME_CANNOT_BE_EMPTY: 'Name cannot be empty',
    NAME_IS_INVALID: 'Name is invalid;',
    NAME_IS_REQUIRED: 'Name cannot be empty',
    NAME_OF_ASSOCIATION: 'Organization name',
    NAME1: 'Name',
    NAME2: 'Name',
    NAME3: 'Name',
    NEEDS_REVIEW_AND_CONFIRMATION: 'Verification required',
    NEW_REPORT_FIELDS_ON_DATA: 'Add data on report field:',
    NEW_TYPE: 'New type',
    NO: 'No',
    NO_CHANGES: 'No changes have been made',
    NO_COMPANY_SELECTED: 'No company selected!',
    NO_CORRESPONDING_DEVICE_CODE_FOUND: 'The system cannot find the corresponding device code!',
    NO_DATA: 'No data',
    NO_DATA_DETECTED: 'No data detected!',
    NO_DATA_IMPORTED: 'No data imported',
    NO_EDITABLE_ITEMS_FOUND: 'No editable items found',
    NO_FILE_CORRESPONDING_TO_THE_ID: 'There is no file corresponding to this ID',
    NO_PASSWORD_SETTINGS_SELECTED: 'No password settings selected',
    NO_REASON_TO_ENTER: 'No reason found for stock in',
    NO_SUCH_CUSTOMER_POSITION: 'No such customer position;',
    NO_SUCH_ORGANIZATION_TYPE: 'No such organization type;',
    NO_SUCH_PARENT_ORGANIZATION_NAME: 'No such parent organization name;',
    NO_SUCH_SHOP: 'No such store;',
    NO_SUCH_SHOP_NAME: 'No such store name;',
    NO_SUCH_USER_INFORMATION: 'No such user information;',
    NO_SUPERIOR_USER_INFORMATION: 'No superior user information;',
    NO_TEMPORARY_DIRECTORY_WAS_FOUND: 'Temporary directory is not found',
    NO1: 'No',
    infoapi_common_000024: 'No',
    NON_RETAIL_SYSTEM: 'Non-retail system',
    NONRETAIL_SYSTEM: 'Non-retail system',
    infoapi_common_000028: 'Non-retail system',
    NONE_OF_THE_SELECTED_STORES_HAVE_A_STORE_NUMBER_AND_CANNOT_GENERATE_A_REPAIR_CODE: 'None of the selected stores have a store code and cannot generate a maintenance code',
    NOT_CONNECTED_TO_THE_INTERNET: 'Not connected to the internet',
    NUMBER_OF_ATTACHMENTS: 'Number of attachments',
    NUMBER_OF_CATEGORIES: 'Number of categories',
    NUMBER_OF_COMMENTS: 'Message number',
    NUMBER_OF_DAILY_GUESTS: 'Daily customer flow',
    NUMBER_OF_ENTRIES: 'Number of entries',
    NUMBER_OF_FAILED_ITEMS: 'Unqualified Quantity',
    NUMBER_OF_INSPECTION_ITEMS: 'Number of inspection items',
    NUMBER_OF_LEVELS_OF_SUPERIOR_ORGANIZATION_PERSONNEL_ALLOWED_TO_VIEW: 'Level of upper organization allow to view',
    NUMBER_OF_MEMBERS: 'Number of members',
    NUMBER_OF_N_A_ITEMS: 'N/A Quantity',
    NUMBER_OF_PHOTOS: 'Number of photos',
    NUMBER_OF_PRODUCTS: 'Product No.',
    NUMBER_OF_QUALIFIED_ITEMS: 'Number of qualified items',
    NUMERIC: 'Numeric',
    OFFICE_ADDRESS: 'Address',
    OFFICE_NUMBER: 'Office phone',
    OFFICE_PHONE: 'Work phone',
    OFFSET_COEFFICIENT: 'Offset value',
    OFFSET_VALUE: 'Offset value',
    OK_TO_GENERATE_REPAIR_CODE: 'Confirm to generate maintenance code?',
    OK_TO_REFRESH_ALL_SHOP_REPAIR_SPECIALISTS: 'Confirm to  refresh all store maintenance specialist?',
    ON_MONDAY: 'Monday',
    ON_SATURDAY: 'Saturday',
    ON_TUESDAY: 'Tuesday',
    ON_WEDNESDAY: 'Wednesday',
    ONLINE_TRAINING: 'Online training',
    ONLY_SELECT_SHOPS: 'Select store only',
    ONLY_WORD_DOCUMENTS_ARE_SUPPORTED: 'Only word document are supported',
    OPEN_ADDRESS_BOOK: 'Open address book',
    OPEN_INQUIRY: 'Open inquiry',
    OPEN_SHOP: 'Open store',
    OPENING_DATE: 'Opening date',
    OPERATION_FAILED: 'Operation failed',
    OPERATION_IS_INVALID_BIRTH_TIME_CANNOT_EXCEED_CURRENT_TIME: 'Operation invalid, birth time cannot exceed current time',
    OPERATOR: 'Operator',
    OPTION: 'Option',
    OPTION_INFORMATION: 'Option information',
    OPTION_MODIFICATION: 'Modify option',
    OPTION_OR_CONTENT_CANNOT_BE_EMPTY: 'Option or content cannot be empty',
    ORDER: 'Order',
    ORDINARY_STRENGTH: 'Ordinary strength',
    ORGANIZATION: 'Organization',
    ORGANIZATION_CODE: 'Organization code',
    ORGANIZATION_DATA_IMPORT: 'Import organization data',
    ORGANIZATION_DATA_TEMPLATE: 'Organization template',
    ORGANIZATION_DIRECTORY: 'Organization directory',
    ORGANIZATION_HANDOVER: 'Organization daily log',
    ORGANIZATION_INFORMATION: 'Organization information',
    ORGANIZATION_LIST: 'Organization list',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY: 'Organization name cannot be empty',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY1: 'Organization name cannot be empty',
    worker_common_000005: 'Organization name cannot be empty',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY2: 'Organization name cannot be empty!',
    ORGANIZATION_STRUCTURE_SETTING: 'Organization structure settings',
    TREE_MENU_DOMAIN_MANAGEMENT: 'Organization structure settings',
    ORGANIZATION_TYPE: 'Organization type',
    ORGANIZATION_TYPE_CANNOT_BE_EMPTY: 'Organization type cannot be empty',
    ORGANIZATION_TYPE_CANNOT_BE_EMPTY1: 'Organization type cannot be empty;',
    ORGANIZATION_TYPE_CANNOT_BE_SHOP: 'Organization type cannot be store;',
    ORGANIZATION_TYPE1: 'Organization type:',
    ORGANIZATION1: 'Organization',
    ORGANIZATION2: 'Affiliated organization',
    ORGANIZATIONDEPARTMENT_NAME: 'Organization/ department name',
    ExcelTemplate_common_000011: 'Organization Name',
    OTHER_INFORMATION: 'Other information',
    OUT_OF_STOCK: 'Stock out',
    OUTBOUND: 'Outbound',
    OUTBOUNDINBOUND: 'Stock in/ out',
    OUTGOING_NUMBER: 'Outgoing number',
    OWNED_MALL: 'Located mall',
    PARENT_CATEGORY_IS_NOT_LOADED: 'Parent category is not loaded',
    PARENT_FOLDER: 'Parent folder',
    PARENT_ORGANIZATION: 'Parent organization',
    PART_OF_THE_DATA_IS_IMPORTED_SUCCESSFULLY_DO_YOU_DOWNLOAD_THE_PROMPT_FILE_TO_VIEW_THE_WRONG_DATA: 'Part of data was imported, do you want to download the error log?',
    PASSENGER_CHANNEL: 'Customer flow channel',
    PASSENGER_CHANNEL_IMPORT_TEMPLATE: 'Customer flow template',
    PASSENGER_CHANNEL_INFORMATION: 'Customer flow channel information',
    PASSENGER_DATA_IMPORT: 'Import customer flow',
    PASSENGER_DATA_IS_ARCHIVED: 'Customer flow data has been archived',
    PASSENGER_DATA_TEMPLATE: 'Customer flow template',
    PASSENGER_EQUIPMENT_INFORMATION: 'Customer flow device information',
    PASSENGER_FLOW_ADJUSTMENT: 'Customer flow adjustment',
    PASSENGER_FLOW_ADJUSTMENT_LIST: 'Customer flow adjustment list',
    PASSENGER_FLOW_EQUIPMENT: 'Customer flow device',
    PASSENGER_FLOW_INFORMATION: 'Customer flow information',
    PASSENGER_FLOW_INFORMATION_ADDED: 'Add customer flow information',
    PASSENGER_FLOW_INFORMATION_UPDATE: 'Update customer flow information',
    PASSENGER_FLOW_MANAGEMENT: 'Customer flow management',
    PASSENGER_FLOW_STATISTICS: 'Customer flow statistic',
    PASSING_SCORE: 'Qualified score',
    PASSWORD: 'Password',
    PASSWORD_IS_TOO_LONG: 'Password is too long',
    PASSWORD_IS_TOO_SHORT: 'Password is too short',
    PASSWORD_RESET_SUCCEEDED: 'Password reset successful',
    PENDING_REVIEW: 'Pending review',
    PEOPLE_DATA_TEMPLATE: 'Staff template',
    PEOPLE_LIST: 'Staff list',
    PERCENTAGE: 'Percentage',
    PERFORMANCE_APPRAISAL: 'Performance evaluation',
    m_info_common_000023: 'Performance evaluation',
    PERFORMANCE_APPRAISAL_REPORT: 'Performance evaluation',
    PERFORMANCE_APPRAISAL_REPORT1: 'Performance evaluation report',
    PERFORMANCE_APPRAISAL_TEMPLATE: 'Performance evaluation template',
    PERMISSION_INFORMATION: 'Permission information',
    PERSONAL_INFORMATION: 'Personal information',
    PERSONNEL_ASSESSMENT_TEMPLATE_IMPORT: 'Import staff assessment template',
    PERSONNEL_INFORMATION: 'Staff information',
    PERSONNEL_MANAGEMENT: 'Staff management',
    PHASE_ENDS_ON_DAY_OF_DAY_MUST_BE_NUMERIC: 'How many days when the phase end should be numeric',
    PHASE_ENDS_ON_DAYS_MUST_BE_GREATER_THAN_0: 'How many days when the phase end should be greater than 0',
    PHASE_STARTS_ON_DAY_OF_DAY_MUST_BE_NUMERIC: 'How many days when the phase begins should be numeric',
    PHASE_STARTS_ON_THE_FIRST_FEW_DAYS_AND_MUST_BE_GREATER_THAN_0: 'How many days when the phase begins should be greater than 0',
    PHONE: 'Mobile No.',
    PHONE_NUMBER: 'Mobile phone',
    PHONE_NUMBER_CANNOT_BE_EMPTY: 'Mobile phone number cannot be empty',
    PICTURE_FORMAT_IS_NOT_SUPPORTED: 'Image format not supported',
    PICTURE_UPLOADED_SUCCESSFULLY: 'Image uploaded successfully',
    PLANNING_TIME: 'Planning time',
    PLEASE_ADD_PASSENGER_FLOW_DATA: 'Please add customer flow data',
    PLEASE_CHECK_THE_DATA: ',please check the data',
    PLEASE_CHECK_THE_REQUIRED_FIELDS: '　Please check the required fields',
    PLEASE_CHOOSE: 'Please select',
    PLEASE_CHOOSE_TO_UPLOAD_A_FILE: 'Please select the file you want to upload!',
    PLEASE_CONFIRM_WHETHER_TO_RESET_THE_SELECTED_USER_PASSWORD: 'Please confirm whether to reset the selected user password?',
    PLEASE_COPY: 'Please copy:',
    PLEASE_ENTER_PASSENGER_FLOW_DATA: 'Please enter passenger flow data!',
    PLEASE_ENTER_SALES_DATA: 'Please enter sales data!',
    PLEASE_ENTER_THE_SERVICE_CODE: 'Please enter the service code',
    PLEASE_FILL_IN_THE_ATTACHMENT_CATEGORY_AND_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: 'Please enter attachments category and subject, then select upload file.',
    PLEASE_FILL_IN_THE_INFORMATION_CATEGORY_AND_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: 'Please enter the information category and title, then choose to upload file!',
    PLEASE_FILL_IN_THE_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: 'Please enter the title and choose to upload the file!',
    PLEASE_SELECT: 'Please select',
    PLEASE_SELECT_A_CATEGORY: 'Please select a product code category',
    PLEASE_SELECT_A_CUSTOMER: 'Please select a customer',
    PLEASE_SELECT_A_DOCUMENT_TO_DOWNLOAD: 'Please select the document you want to download',
    PLEASE_SELECT_A_DOWNLOAD_TEMPLATE: 'Please select the template you want to download',
    PLEASE_SELECT_A_FILE: 'Please select a file.',
    PLEASE_SELECT_A_FILE_TO_UPLOAD: 'Please select file to upload!',
    PLEASE_SELECT_A_FROZEN_REPAIR_CODE: 'Please select the frozen maintenance code',
    PLEASE_SELECT_A_MODIFICATION: 'Please select modify item',
    PLEASE_SELECT_A_NODE: 'Please select a node',
    PLEASE_SELECT_A_PARENT_ORGANIZATION: 'Please select a parent organization',
    PLEASE_SELECT_A_PICTURE: 'Please select a Image',
    PLEASE_SELECT_A_PRODUCT_CATEGORY: 'Please select product category',
    PLEASE_SELECT_A_PRODUCT_CATEGORY1: 'Please select a product category',
    PLEASE_SELECT_A_PROP_CATEGORY: 'Please select prop category',
    PLEASE_SELECT_A_REPAIR_CATEGORY: 'Please select maintenance category',
    PLEASE_SELECT_A_SHOP: 'Please select store',
    PLEASE_SELECT_A_STICKY_ITEM: 'Please select a unsticky item',
    PLEASE_SELECT_A_SUITABLE_PASSWORD_LENGTH: 'Please choose the appropriate password length',
    PLEASE_SELECT_A_USER: 'Please select user',
    PLEASE_SELECT_AN_ITEM: 'Please select an item',
    PLEASE_SELECT_AN_ITEM_TO_DEACTIVATE: 'Please select item to deactivate',
    PLEASE_SELECT_AN_ITEM_TO_UNPIN: 'Please select the item to unstick it',
    PLEASE_SELECT_AN_ORGANIZATION_NODE: 'Please select an organization node',
    PLEASE_SELECT_ASSET_CLASS: 'Please select asset category',
    PLEASE_SELECT_EXPORT_DATA: 'Please select the data you want to export',
    PLEASE_SELECT_ITEM_CATEGORY: 'Please select prop category',
    PLEASE_SELECT_THE_COMPANY_YOU_WANT_TO_LOGIN: 'Please select the company you want to log in',
    PLEASE_SELECT_THE_COMPETITION_CATEGORY: 'Please select competing product category',
    PLEASE_SELECT_THE_FROZEN_REPAIR_CODE: 'Please select maintenance code to unfreeze',
    PLEASE_SELECT_THE_ITEM_CATEGORY: 'Please select prop category',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_DELETE: 'Select the items you want to delete',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_ENABLE: 'Select the items you want to enable',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_PIN: 'Please select the item you wish to stick to top',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_UNFREEZE: 'Please select the item you want to unfreeze',
    PLEASE_SELECT_THE_ITEMS_THAT_NEED_TO_BE_FROZEN: 'Please enter the item you want to freeze',
    PLEASE_SELECT_THE_STORE_TO_BE_EDITED: 'Please select the store you want to edit',
    PLEASE_SELECT_THE_TOPICS_YOU_WANT_TO_ADD: 'Please select the topic you want to add.',
    PLEASE_SELECT_UNPIN: 'Please select unstick',
    PLEASE_SELECT_UPLOAD_FILE: 'Please select the file you want to upload',
    PLEASE_SELECT_WHO_YOU_WANT_TO_SEND: 'Please select the person to you want to send to!',
    PLEASE_UPLOAD_A_600_600_PIXEL_IMAGE: 'Please upload a 600 by 600 pixel image',
    PLEASE_UPLOAD_A_COURSEWARE_PICTURE: 'Prop upload a courseware Image',
    POINT_BOOK_LIST: 'Point book list',
    POSITION: 'Position',
    POSITION_MANAGEMENT: 'Position management',
    POSITION_SELECTION: 'Position selection',
    POSITION1: 'Job title',
    POST_FORM: 'Publish form:',
    POST_INFORMATION: 'Thread information',
    POSTCODE: 'Postal code',
    PRICE: 'Price',
    PROBLEM_CATEGORY_NAME: 'Question category name',
    PROBLEM_DESCRIPTION: 'Description of Issue',
    PROBLEM_INFORMATION: 'Question information',
    PROBLEM_MODIFICATION: 'Modify question',
    PROBLEM_NAME: 'Question title',
    PROBLEM_WEIGHT: 'Question weights',
    PROCESSING: 'In progress',
    PRODUCT_CATEGORY_ADDED_SUCCESSFULLY: 'Product category added successfully',
    PRODUCT_CATEGORY_IMPORT: 'Product category import',
    PRODUCT_CATEGORY_MODIFIED_SUCCESSFULLY: 'Product category modified successfully',
    PRODUCT_CLASSIFICATION_INFORMATION: 'Product category information',
    PRODUCT_DATA_IMPORT: 'Product data import',
    PRODUCT_ID: 'Product ID',
    PRODUCT_INFORMATION: 'Product information',
    PRODUCT_INFORMATION_IMPORT: 'Product information import',
    PRODUCT_LEVEL_1_CLASSIFICATION: 'Product L1 category',
    PRODUCT_LEVEL_1_CLASSIFICATION_NAME: 'Product L1 category name',
    PRODUCT_NAME: 'Product name',
    PRODUCT_NAME1: 'Product name',
    PRODUCT_NUMBER: 'Product code',
    PROJECT_MANAGER: 'Project manager',
    PROMPT: 'Prompt',
    PROMPT_MESSAGE: 'Prompt message',
    PROP_DATA_IMPORT: 'Import props data',
    PROP_DOES_NOT_EXIST: 'Props do not exist;',
    PROP_IMAGE: 'Props image:',
    PROPS_CATEGORY_PICTURES: 'Props category images',
    PROVINCE_NAME: 'Province name',
    PUBLIC_DOCUMENT: 'Public folders',
    PURCHASE_DATE: 'Date of purchase',
    PURCHASE_HISTORY: 'Purchase history',
    PURCHASE_INFORMATION: 'Purchase information',
    PURCHASE_RECORD_IMPORT: 'Import purchase record',
    PURCHASE_RECORD_TEMPLATE: 'Purchase record template',
    PURCHASE_TIME: 'Purchase time',
    PURPOSE_OF_RETURN_VISIT: 'Return visit objective',
    PUSH: 'Push',
    PUSH_TARGET: 'Push target',
    QUANTITY: 'Quantity',
    QUERY_CONDITIONS: 'Search',
    QUERY_ORGANIZATION_TAG: 'Search organization tag',
    QUESTION_ANSWER: 'Answer',
    QUESTION_BANK_ADD: 'Add question bank',
    QUESTION_BANK_MANAGEMENT: 'Question bank management',
    QUESTION_CATEGORY: 'Question category',
    QUESTION_CODE: 'Question code',
    QUESTION_NUMBER: 'Exam paper code',
    QUESTION_NUMBER1: 'Question code',
    QUESTION_TITLE: 'Question title',
    QUESTION_TYPE: 'Exam paper type',
    QUESTION_TYPE1: 'Question type',
    QUESTIONS_IN_USE_CANNOT_BE_DELETED: 'The questions in use and cannot be deleted',
    R_ACADEMY: 'R+ academy',
    RANDOM_PASSWORD: 'Random password',
    RANGE_LIMITATION: '）Range limitation;',
    REACHING_THIS_VALUE_THE_SCORES_FOR_THIS_BROAD_CATEGORY_ARE: 'Reaching this value, the score for this major category is:',
    RECEIVE_CC: 'Receive/ CC',
    RECIPIENT: 'Recipient',
    RECIPIENT_ORGANIZATION: 'Recipient Organization',
    RECOGNITION_SUCCESS: 'Recognized successfully',
    RECORDING_METHOD: 'Record mode',
    REFERENCE_DESCRIPTION: 'Reference description',
    REFERENCE_FORM: 'Reference form',
    REFRESH: 'Refresh',
    REFRESH_FAILED: 'Refresh failed',
    REFRESH_SUCCESSFUL: 'Refreshed successfully',
    REFUSE: 'Rejected',
    REGION_DATA_TEMPLATE: 'Location template',
    REGION_SELECTION: 'Select location',
    REGIONAL_DATA_IMPORT: 'Import location',
    REJECTED: 'Rejected',
    RELATED_SHOPS: 'Related store',
    RELEASE_DATE: 'Release date',
    RELEASE_TIME: 'Release time',
    REMARK: 'Remark',
    REMARK1: 'Remark',
    REMARK2: 'Remarks',
    REMINDER: 'Reminder',
    REMOVE_BRAND: 'Delete brand',
    REMOVE_BRAND_TYPE: 'Delete brand type',
    REMOVE_DEALER: 'Delete vendor',
    REMOVE_DEALER_TYPE: 'Delete vendor type',
    REMOVE_DEFECTIVE_PARTS: 'Delete defective parts',
    REMOVE_DEFECTIVE_PRODUCT: 'Delete defective product',
    REMOVE_DEFECTIVE_PRODUCT_CLASSIFICATION: 'Delete defective product category',
    REMOVE_GPS: 'Delete GPS',
    REMOVE_ITEM_CATEGORY: 'Delete prop category',
    REMOVE_LAND_PASSENGER_CONVERSION_RATE: 'Delete customer flow conversion rate',
    REMOVE_MAINTENANCE_ISSUES: 'Delete maintenance issue',
    REMOVE_RETAIL_TOUR_TEMPLATE: 'Delete checklist template',
    REMOVE_RETAIL_TOUR_TEMPLATE_ISSUE: 'Delete checklist item template',
    REMOVE_STORE_VENDOR: 'Delete store vendor',
    REMOVE_TRACKING: 'Delete item tracker',
    REMOVE_VENDOR_TYPE: 'Delete vendor type',
    REMOVE_VISUAL_DISPLAY: 'Delete VM',
    REPAIR_APPLICATION: 'Maintenance application form',
    REPAIR_CATEGORY: 'Maintenance category',
    REPAIR_CATEGORY_INFORMATION: 'Maintenance category information',
    REPAIR_CLASSIFICATION: 'Maintenance category',
    REPAIR_CODE: 'Maintenance code',
    REPAIR_CODE_IS_FROZEN: 'Maintenance code is frozen',
    REPAIR_CODE_IS_NOT_FROZEN: 'Maintenance code is not frozen',
    REPAIR_CODE_STATUS: 'Maintenance code status',
    REPAIR_FAILURE: 'Maintenance fault',
    REPAIR_FAILURE_INFORMATION: 'Maintenance fault information',
    REPAIR_INFORMATION: 'Maintenance information',
    REPAIR_MODULE_CONFIGURATION: 'Maintenance module configurations',
    REPAIR_NAME: 'Maintenance name',
    REPLIES: 'Replied quantity',
    REPORT_CATEGORY: 'Report category',
    REPORT_CENTER: 'Report center',
    m_info_common_000002: 'Report Center',
    REPORT_DATE: 'Report date',
    REPORT_DESCRIPTION: 'Report description',
    REPORT_MANAGEMENT: 'Report management',
    REPORT_NAME: 'Report name',
    REPORT_NUMBER: 'Report code',
    REPORT_PERMISSION_SETTINGS: 'Report permission settings',
    REQUEST_CANCELLATION_REPORT_EXPIRY_TIME: 'Request cancellation of report expiry time',
    REQUIRED: '　　　　　　　　　　　　　Required',
    REQUIRED1: '　　　　　　　　　　　　　　Required',
    RESELLER_DATA_TEMPLATE: 'Vendor template',
    RESET: 'Reset',
    RESET_PASSWORD: 'Reset password',
    RESET_PASSWORD_MAIL: 'Reset password (Email)',
    RESET_PASSWORD_SMS: 'Reset password (SMS)',
    RESTORE: 'Restore',
    RESTRICT_ORGANIZATION_INFORMATION: 'Restrict organization information',
    RESTRICTED_CATEGORY: 'Restricted category',
    RESTRICTED_ORGANIZATION: 'Restricted organization',
    RESTRICTED_REPAIR_CATEGORIES: 'Restricted maintenance category',
    RETAIL_MANAGEMENT: 'Retail management',
    RETAIL_TOUR: 'Checklist',
    RETAIL_TOUR_REPORT: 'Checklist report',
    RETAIL_TOUR_STORE_TEMPLATE: 'Checklist template',
    RETURN_NAME: 'Return visit name',
    RETURN_NUMBER: 'Return visit mobile number',
    RETURN_NUMBER1: 'Return visit code',
    RETURN_VISIT_DETAILS: 'Return visit details',
    RETURN_VISIT_GUIDANCE: 'Return visit guide',
    RETURN_VISIT_INFORMATION: 'Return visit information',
    RETURN_VISIT_PLAN: 'Return visit plan',
    RETURN_VISIT_RECORDS: 'Return visit record',
    RETURN_VISIT_RESULTS: 'Return visit result',
    RETURN_VISIT_TIME: 'Return visit time',
    REVERSE_ORDER: 'Reverse order',
    REVERSE_ORDER1: 'Reverse order',
    REVISITED: 'Return visit customer',
    RIGHTS_PROFILE: 'Permission setting',
    ROLE_DATA_IMPORT: 'Import role data',
    ROLE_DATA_TEMPLATE: 'Role data template',
    ROLE_DETAILS: 'Role details',
    ROLE_INFORMATION: 'Role information',
    ROLE_LOOK_UP: 'Role (look up)',
    ROLE_NAME: 'Role name',
    ROLE_NAME_CANNOT_BE_EMPTY: 'Role name cannot be empty',
    ROLE_NAME_CANNOT_BE_EMPTY1: 'Prop name cannot be empty!',
    ROLE_PERMISSIONS: 'Role permissions',
    ROLE_SELECTION: 'Role selection',
    ROLE_TEMPLATE_SETTINGS: 'Role template settings',
    ROLES: 'Role',
    ExcelTemplate_common_000010: 'Role name',
    ROLES1: 'Role',
    RPLUS: '[RPLUS]',
    SAFETY_STOCK: 'Safety stock',
    SALES_DATA_IMPORT: 'Import sales record',
    SALES_DATA_IS_ARCHIVED: 'Sales data has been archived',
    SALES_DATA_TEMPLATE: 'Sales data template',
    SALES_INFORMATION: 'Sales information',
    SALES_INFORMATION_UPDATE: 'Sales information update',
    SALES_MANAGEMENT: 'Sales management',
    SALES_REPORT: 'Sales report',
    m_info_common_000038: 'SalesReport',
    SALES_STATISTICS: 'Sales statistic',
    SAVE: 'Save',
    SAVE_FAILED: 'Save failed',
    SAVE_THE_CONFIGURATION: 'Save the configurations',
    SAVED_SUCCESSFULLY: 'Saved successfully',
    SCORE: 'Score',
    SCORE_DISPLAY: 'Score display',
    SCORE_VALUE: 'Score value',
    SCORING_METHOD: 'Score method',
    SCORING_MODE: 'Score mode',
    SEARCH_FOR: 'Search',
    SELECT: 'Select',
    SELECT_ALL: 'Select all',
    SELECT_ALL_STORES: 'Select all stores',
    SELECT_EMAIL_LANGUAGE: 'Select email language',
    SELECT_GOODS: 'Select product',
    SELECT_IMAGE: 'Select image',
    SELECT_SHOP: 'Select store',
    SELECT_SUPERIOR: 'Select superior',
    SELECTED_ANSWER: 'Selected answer',
    SELECTED_NODE_ID: 'Selected node ID:',
    SELECTIVE: 'Select option',
    SEND: 'Send',
    SEND_DATE: 'Send date',
    SEND_HEADER_CANNOT_BE_EMPTY: 'Header cannot be empty!',
    SEND_MESSAGES: 'Send message',
    SEND_SIGNATURE_CANNOT_BE_EMPTY: 'Signature cannot be empty!',
    SENDER: 'Sender',
    SENDER1: 'Sender',
    SENDING_CONTENT_CANNOT_BE_EMPTY: 'Content cannot be empty!',
    SEQUENCE_NUMBER: 'Serial number',
    SERIAL_NUMBER: 'Serial number',
    SERIAL_NUMBER1: 'Serial number',
    SERVE: 'Position',
    SERVICE_CODE: 'Service code',
    SERVICE_TYPE: 'Service type',
    SERVICE_TYPE1: 'Service type:',
    SET_AS: 'Set as',
    SET_CURRENCY: 'Set currency',
    SET_FAULT_CLASSIFICATION: 'Set fault category',
    SET_ROLE: 'Set role',
    SET_UP: 'Setup',
    SET_UP_SUCCESSFULLY: 'Set up successfully',
    SETUP_FAILED: 'Setup failed',
    SEX_FAREWELL: 'Gender',
    SHOP: 'Store',
    SHOP_ACCESSORIES: 'Store attachment',
    SHOP_ADRESS: 'Store address',
    SHOP_AREA: 'Store area',
    SHOP_ENGLISH_NAME: 'Store Name (EN)',
    SHOP_EQUIPMENT: 'Store device',
    SHOP_FAX: 'Store Fax',
    SHOP_ID: 'Store ID',
    SHOP_INSPECTION: 'Checklist',
    m_info_common_000008: 'Checklist',
    SHOP_INSPECTION_DATA_IMPORT: 'Checklist data import',
    SHOP_INSPECTION_MODULE_CONFIGURATION: 'Checklist module configurations',
    SHOP_INSPECTION_PROBLEM_CATEGORIES: 'Checklist issue category',
    SHOP_INSPECTION_REPORT: 'Checklist report',
    SHOP_INSPECTION_TEMPLATE: 'Checklist template',
    SHOP_INSPECTOR: 'Checked by',
    SHOP_LABEL: 'Store tag',
    SHOP_MAILBOX: 'Store email',
    SHOP_MAINTENANCE: 'Store maintenance',
    SHOP_NUMBER: 'Store code',
    SHOP_PROPS_IMPORT: 'Import store prop',
    SHOP_REPAIR: 'Store maintenance',
    m_info_common_000026: 'Store maintenance',
    SHOP_REPAIR_EMAIL: 'Store maintenance email',
    SHOP_REPAIR1: 'Store maintenance',
    SHOP_STAFF: 'Store staff',
    infoapi_common_000027: 'Store staff',
    SHOP_TOUR_PLAN: 'Checklist plan',
    m_info_common_000030: 'Checklist plan',
    SHOP_TOUR_PREVIEW: 'Checklist preview',
    SHOP_TOUR_REPORT: 'Checklist report',
    SHOP_TOUR_TEMPLATE: 'Checklist template',
    m_info_common_000003: 'Checklist template',
    SHOP_TYPE: 'Store type',
    SHOP_VISIT_ENTRY: 'Checklist entry',
    SHOPPING_MALL_APPLICATION_REQUIREMENTS: 'Shopping mall business license requirements',
    SHORT_NAME: 'Abbreviation',
    SHOW_DEPRECATED: 'Show deprecated',
    SHOW_REPAIR_COSTS: 'Show maintenance costs',
    SHOW_SCORE_IN_PDF: 'Show score in pdf',
    SHOW_SUBORDINATES: 'Show subordinate',
    SHUT_DOWN: 'Close',
    SIGNATURE: 'Signature',
    SIGNING_TIME: 'Signing time',
    SIMPLIFIED_CHINESE: 'Simplified Chinese',
    SINGLE_FILE_SIZE_EXCEEDS: 'Single file size exceeds',
    SIZE: 'Size',
    SMALL_CLASS_DOES_NOT_EXIST: 'Minor category does not exist',
    SMS_NOTIFICATION: 'SMS notification',
    SMS_VERIFICATION: 'SMS verification',
    SORRY_SOMETHING_WENT_WRONG: 'Sorry, something went wrong',
    SORRY_THE_DEALER_HAS_BEEN_USED_IN_BUSINESS_DATA_AND_CANNOT_BE_DELETED: 'Sorry, this vendor has been used in the business data, it can not be deleted',
    SORRY_THE_PROGRAM_DOES_NOT_ALLOW_FILE_DOMAINS_WITH_THE_SAME_NAME_ATTRIBUTE: 'Sorry, the program does not allowed to use the same properties of the file fields!',
    SORRY_YOU_ARE_NOT_A_SYSTEM_ADMINISTRATOR_PLEASE_CONTACT_YOUR_SYSTEM_ADMINISTRATOR: 'Sorry, you are not a system administrator, please contact your system administrator.',
    SORRY_YOUR_PASSWORD_IS_WRONG_PLEASE_REENTER: 'Sorry, your password is incorrect, please re-enter',
    SORRY_YOUR_SOFTWARE_LICENSE_HAS_EXPIRED_PLEASE_CONTACT_R__SYSTEM_ADMINISTRATOR: 'Sorry, your software license has expired, please contact R + system administrator',
    SORRY_YOUR_USER_ACCOUNT_IS_LOCKED: 'Sorry, your account has been locked',
    SORT: 'Sorting',
    SORT_FIELDS: 'Sort fields',
    SPECIAL_CHARACTERS_ARE_NOT_ALLOWED: 'No special characters allowed',
    SPECIAL_TASK_TEMPLATE: 'Special task template',
    SPECIFICATION: 'Specification',
    STAFF_APPOINTMENT_DATA_TEMPLATE: 'Staff employment data template',
    STAFF_ASSESSMENT_TEMPLATE: 'Staff assessment template',
    STAFF_MANAGEMENT: 'Staff management',
    STANDARD_CURRENCY: 'Standard currency',
    STANDARD_CURRENCY_CANNOT_BE_EMPTY: 'Standard currency cannot be empty',
    STANDARD_MODE: 'Standard mode',
    STAR_BRAND: '*Brand',
    STAR_DEFAULT_CURRENCY: '*Default Currency',
    STAR_SHOP_LANGUAGE: '*Store Language',
    STARSTORE_NAME: '*Store Name',
    START_DATE: 'Start date',
    STARTING_TIME: 'Start time',
    STARTUP_PAGE_DIAGRAM: 'Startup page',
    STATISTIC_TYPE: 'Statistic Type',
    STATISTICAL_DATE: 'Statistical date',
    STATUS: 'Status',
    ExcelTemplate_common_000012: 'Status',
    STATUS_QUERY: 'Search status',
    STICKY: 'Stick',
    STICKY_COURSE: 'Sticky course',
    STOCK_TRACKING_DATA_TEMPLATE: 'Item tracking data template',
    STORE_AGENT: 'Store agent',
    STORE_AREA_INPUT_VALUE_IS_INCORRECT: 'Store area input value is incorect;',
    STORE_ASSETS: 'Store assets',
    STORE_CATEGORIES_IN_USE_CANNOT_BE_DELETED: 'Store category is in use and cannot be deleted!',
    STORE_CATEGORY: 'Store category',
    STORE_CATEGORY1: 'Store category',
    STORE_CODE_CANNOT_BE_EMPTY: 'Prop code cannot be empty',
    STORE_CONTACT: 'Contact person',
    STORE_DATA_IMPORT: 'Store data import',
    STORE_DATA_TEMPLATE: 'Store data template',
    STORE_DOCUMENT: 'Store document',
    STORE_EQUIPMENT_DATA_TEMPLATE: 'Store device data template',
    STORE_FIELD_CONFIGURATION: 'Store field configurations',
    STORE_ID: 'Store ID',
    STORE_INFORMATION: 'Store information',
    STORE_INSPECTION_REPORT_EDIT: 'Modify checklist report',
    STORE_LONGITUDE_INPUT_IS_WRONG: 'Prop longitude input is wrong',
    STORE_MANAGEMENT: 'Store management',
    STORE_MONITORING: 'Store monitoring',
    STORE_MONITORING_LIST: 'Store monitoring list',
    STORE_NAME: 'Store name',
    STORE_NAME_ALREADY_EXISTS: 'Store name already exists',
    STORE_NAME_CANNOT_BE_EMPTY: 'Store name cannot be empty',
    STORE_PHONE: 'Store Contact Number',
    STORE_POSTCODE_ENTERED_INCORRECT_VALUE: 'Prop postcode entered incorrect value',
    STORE_REPAIR_CODE_MANAGEMENT: 'Store maintenance code management',
    STORE_REPAIR_SPECIALIST_WILL_BE_GENERATED_LATER: 'Store maintenance specialist will be generated later',
    STORE_STOREID_DOES_NOT_BELONG_TO_THE_BUSINESS: 'Store ID does not belong to this enterprise',
    STORE_TYPE_DETAILS: 'Store type details',
    STORE_TYPE_INFORMATION: 'Store type information',
    STORE_TYPE_NAME: 'Store type name',
    STORE_TYPE_NUMBER: 'Store type code',
    STORES_CANNOT_ADD_SUBORDINATE_ORGANIZATIONS: 'Stores cannot add subordinate organizations',
    STRING: 'String',
    STUDYTIME: 'Study time',
    SUB_ACCOUNT: 'Sub account',
    SUBHEADINGS: 'Parent category',
    SUBMIT_CONTENT: 'Submit content',
    SUBORDINATE_POSITIONS: 'Subordinate position',
    SUBSTANDARD_SCORE: 'Unqualified score',
    SUCCESS: 'Success',
    SUCCESSFUL_OPERATION: 'Operated successfully',
    SUCCESSFUL_OPERATION1: 'Operated successfully!',
    SUCCESSFUL_RECOVERY: 'Recovered successfully',
    SUCCESSFUL_SYNCHRONIZATION: 'Synchronized successfully',
    SUCCESSFULLY_DELETED: 'Deleted successfully!',
    SUCCESSFULLY_DELETED_JOB: 'Deleted position successfully',
    SUCCESSFULLY_DELETED1: 'Deleted successfully',
    SUCCESSFULLY_DELETED2: 'Deleted successfully',
    SUCCESSFULLY_MODIFIED: 'Modified successfully',
    SUCCESSFULLY_MODIFIED1: 'Modified successfully!',
    SUIJIE_TECHNOLOGY: '[Rvision]',
    SUNDAY: 'Sunday',
    SUPERIOR: 'Superior',
    SUPERIOR_AREA: 'Higher level location',
    SUPERIOR_SELECTION: 'Select superior',
    SUPPLIER_ALIAS: 'Nickname',
    z_info_common_000005: 'Vendor nickname',
    SUPPLIER_CLASSIFICATION: 'Vendor category',
    SUPPLIER_CONTACT_INFORMATION: 'Vendor contact information',
    SUPPLIER_DATA_IMPORT: 'Import vendor template',
    SUPPLIER_DATA_TEMPLATE: 'Vendor template',
    SUPPLIER_INFORMATION: 'Vendor information',
    SUPPLIER_MANAGEMENT: 'Vendor management',
    SUPPLIER_NAME: 'Vendor name',
    SUPPLIER_NAME1: 'Vendor name:',
    SUPPORTS_DOWNLOADING_UP_TO_50_DOCUMENTS_AT_THE_SAME_TIME: 'Supports downloading up to 50 documents at the same time',
    SURNAME: 'Surname',
    SWITCH_LANGUAGE: 'Switch language',
    SYNC_FAILED: 'Sync failed',
    SYNCHRONIZED_EASY_TO_UNDERSTAND_DATA: 'Synchronize Easy Learning data',
    SYSTEM_HINT: 'Hint',
    SYSTEM_NAME: 'Information management platform',
    HOME_PAGE: 'Home page',
    SELECT_EXPORT_FIELD: 'Select Export Field',
    SELECT_VIEW: 'Export for Read',
    EXPORT_FOLLOW_UP: 'Export follow up',
    CURRENT_SELECT_FIELD: 'Current Selected Fields',
    PARENT_ORGANIZATION_NAME: 'Parent Organization Name',
    WHETHER_ALLOW_MULTIPLE_PEOPLE: 'Multiple Users',
    HAVE_A_JOB: 'Whether to hold a post',
    EXPORT_SUCCESSFULLY: 'Exported successfully',
    SYSTEM_NOTIFICATION: 'System notification',
    SYSTEM_REMINDER: 'System reminder',
    TAG_ID: 'Tag ID',
    TASK_TYPE: 'Task type',
    TASK_TYPE_EDIT: 'Task type modify',
    TEMPLATE_ALREADY_EXISTS: 'Template already exists',
    TEMPLATE_DATA_IMPORT: 'Template data import',
    TEMPLATE_DOES_NOT_EXIST: 'Template does not exist',
    TEMPLATE_EDITING: 'Modify template',
    TEMPLATE_NAME: 'Template name',
    TEMPLATE_NAME_CANNOT_BE_EMPTY: 'Template name cannot be empty;',
    TEMPLATE_NUMBER: 'Template number',
    TEMPLATE_SETTINGS: 'Template settings',
    TEMPLATE_TYPE: 'Template type',
    TEST_PAPER_DESCRIPTION: 'Exam paper description',
    TEST_PAPER_INFORMATION: 'Exam paper information',
    TEST_PAPER_LIST: 'Exam paper list',
    TEST_PAPER_NAME: 'Exam paper name',
    TEST_PAPER_NUMBER: 'Exam paper code',
    TEST_PAPER_NUMBER1: 'Exam paper number',
    TEST_PAPER_REMINDER: 'Exam paper reminder',
    TEST_PAPER_TYPE: 'Exam paper type',
    TEST_SCORE: 'Exam score',
    TEXT: 'Text',
    TEXT_CONTENT_CANNOT_BE_EMPTY: 'Text content cannot be empty',
    THE_ACCOUNT_DOES_NOT_EXIST: 'Account does not exist',
    THE_AREA_NAME_DOES_NOT_EXIST: 'Location name does not exist;',
    THE_BASIC_DATA_IS_INCOMPLETE_PLEASE_MAINTAIN_THE_STORE_CATEGORY: 'Basic data incomplete, please maintain the store category',
    THE_BASIC_DATA_IS_INCOMPLETE_PLEASE_MAINTAIN_THE_STORE_TYPE: 'Basic data incomplete, please maintain the store type',
    THE_BRAND_NAME_DOES_NOT_EXIST: 'The brand name does not exist;',
    THE_CLASSIFICATION_OF_THE_TRANSFER_IN_USE_CANNOT_BE_DELETED: 'This daily log is in use and cannot be deleted!',
    THE_COMPANY_CAN_ADD_PEOPLE_FULL: 'Users which can be added to a company has reached the limit',
    THE_COMPANY_HAS_INSUFFICIENT_REMAINING_ADDABLE_STORES: 'The company has insufficient remaining store to be added',
    THE_COMPANY_HAS_INSUFFICIENT_REMAINING_PERSONNEL_TO_ADD: 'The company has insufficient remaining staff to be added',
    THE_CORRESPONDING_DEVICE_CODE_ALREADY_EXISTS_UNDER_THE_DEVICE_TYPE: 'The corresponding device code already exists under the device type',
    THE_COURSEWARE_YOU_UPLOADED_IS_NOT_A_STANDARD_FORMAT: 'The courseware you uploaded is not a standard format',
    THE_CUSTOMER_DOES_NOT_EXIST: 'The customer does not exist;',
    THE_DATA_IS_INCORRECT_PLEASE_VERIFY: 'Data error, please check your input data',
    THE_DATA_IS_NOT_IMPORTED_PLEASE_WAIT: 'Data has not been imported yet, please wait!',
    THE_DATA_IS_WRONG: 'Data error!',
    THE_DATA_IS_WRONG_DO_YOU_WANT_TO_DOWNLOAD_AND_VIEW_THE_PROMPT_FILE: 'Data error, do you want to download the log file?',
    THE_DEALER_CATEGORY_BEING_USED_CANNOT_BE_DELETED: 'Vendor category in use and cannot be deleted!',
    THE_DEALER_NAME_DOES_NOT_EXIST: 'The dealer name does not exist;',
    THE_DEVICE_NAME_DOES_NOT_HAVE_A_CORRESPONDING_DEVICE_CODE: 'There is no corresponding device code for the device name;',
    THE_DEVICE_TYPE_AND_THE_CORRESPONDING_DEVICE_CODE_ALREADY_EXIST: 'The device type and the corresponding device code already exists',
    THE_DIRECTORY_NAME_IS_INCORRECT: 'Directory name is incorrect',
    THE_DOCUMENT_CLASSIFICATION_IN_USE_CANNOT_BE_DELETED: 'Document category in use and cannot be deleted!',
    THE_ENGLISH_NAME_OF_THE_ITEM_UNDER_THE_SAME_ITEM_CATEGORY_CANNOT_BE_REPEATED: 'Prop names cannot be duplicated under the same prop category;',
    THE_ENTRY_NAME_ALREADY_EXISTS_UNDER_THE_SAME_TEMPLATE_CATEGORY: 'The entry name already exists under the same template category;',
    THE_ENTRY_NUMBER_ALREADY_EXISTS_UNDER_THE_SAME_TEMPLATE_CATEGORY: 'The entry serial number already exists under the same template category;',
    THE_FILE_ID_YOU_WANT_TO_MODIFY_IS_WRONG_PLEASE_TRY_AGAIN_LATER: 'The file ID you want to modify is incorrect, please try again later',
    THE_FILE_TYPE_YOU_ARE_TRYING_TO_MODIFY_IS_INCORRECT_PLEASE_TRY_AGAIN_LATER: 'The file type you are trying to modify is incorrect, please try again later',
    THE_INPUT_VALUE_IS_NOT_IN_THE_VALID_RANGE: 'The input value is not in the valid range',
    THE_LEVEL_DOES_NOT_MATCH_THE_SUPERIOR_LEVEL: 'The level does not match the superior level;',
    THE_MAINTENANCE_CODE_IS_BEING_GENERATED_PLEASE_REFRESH_THE_PAGE_LATER_TO_VIEW: 'Maintenance code is being generated, please refresh the page to view',
    THE_MANUAL_NAME_ALREADY_EXISTS: 'The manual name already exists',
    THE_MAXIMUM_LENGTH_MUST_BE_GREATER_THAN_0: 'The maximum length must be greater than 0!',
    THE_NAME_CANNOT_BE_REPEATED_UNDER_THE_SAME_LEVEL: 'The name cannot be repeated under the same level;',
    THE_NAME_OF_THE_PARENT_ORGANIZATION_CANNOT_BE_EMPTY: 'The name of parent organization cannot be empty',
    THE_NAME_OF_THE_SAME_CLASS_CANNOT_BE_THE_SAME: 'The category name in same level cannot be the same;',
    THE_NAME_OF_THE_SUPERIOR_AREA_DOES_NOT_EXIST: 'The name of the higher level location does not exist;',
    THE_NAMES_OF_MAINTENANCE_FAULTS_UNDER_THE_SAME_MAINTENANCE_FAULT_CLASSIFICATION_ARE_NOT_ALLOWED_TO_BE_DUPLICATED: 'The maintenance name under the same maintenance category cannot be duplicate;',
    THE_NAMES_OF_PASSENGER_FLOW_CHANNELS_UNDER_THE_SAME_STORE_ORGANIZATION_CANNOT_BE_DUPLICATED: 'The name of the customer channel under the same store organization cannot be repeated;',
    THE_NUMBER_OF_STORE_FLOOR_PLANS_HAS_REACHED_THE_UPPER_LIMIT_AND_A_MAXIMUM_OF_TEN_STORE_FLOOR_PLANS_CAN_BE_UPLOADED: 'The number of store floor plans has reached the upper limit, and up to 10 store floor plans can be uploaded.',
    THE_ORGANIZATION_DOES_NOT_EXIST: 'The organization does not exist;',
    THE_ORGANIZATION_NAME_DOES_NOT_EXIST: 'The organization name does not exist;',
    THE_OTHER_PARTY_HAS_BEEN_DELETED: 'The other party account has deleted',
    THE_OTHER_PARTY_IS_FROZEN: 'The other party account has frozen',
    THE_PARENT_ORGANIZATION_CANNOT_BE_THE_CURRENT_ORGANIZATION: 'Parent organization is not current organization',
    THE_PASSWORD_YOU_SET_IS_A_SECURITY_RISK_PLEASE_RESET_IT: 'The password you had set is insecure, please reset it',
    THE_PHONE_NUMBER_IS_INCORRECT: 'Mobile phone number incorrect',
    THE_PHONE_NUMBER_USER_ALREADY_EXISTS: 'The user of this mobile phone number already exists;',
    THE_PRODUCT_NAME_DOES_NOT_EXIST: 'Product name does not exist',
    THE_ROLE_DOES_NOT_ALLOW_MULTIPLE_PEOPLE_TO_TAKE_OFFICE: 'This role cannot be assigned to multiple users;',
    THE_ROLE_DOES_NOT_EXIST: 'This role does not exist',
    THE_ROLE_DOES_NOT_EXIST_UNDER_THE_ORGANIZATION: 'The role does not exist under the organization;',
    THE_ROLE_NAME_ALREADY_EXISTS: 'The role name already exists',
    THE_ROLE_NAME_ALREADY_EXISTS1: 'The role name already exists',
    THE_ROLE_OF_SETTING: 'Role settings',
    THE_SAME_ENTRY_NAME_OR_SERIAL_NUMBER_EXISTS_IN_THE_SAME_TEMPLATE_CATEGORY: 'The entry name or serial number already exists under the same template category',
    THE_SERIAL_NUMBER_CAN_ONLY_BE_NUMERIC_OR_EMPTY: 'The serial number can only be numeric or null',
    THE_SHOP_DOES_NOT_EXIST: 'Store does not exist;',
    THE_SHOP_DOES_NOT_EXIST1: 'The store does not exist;',
    THE_SHOP_NUMBER_ALREADY_EXISTS: 'The store code already exists;',
    THE_SHOP_TYPE_DOES_NOT_EXIST: 'The store type does not exist;',
    THE_SINGULAR_THE_NUMBER_OF_PRODUCTS_AND_THE_TOTAL_SALES_CANNOT_BE_EMPTY_AT_THE_SAME_TIME: 'Transaction, quantity and total sales amount cannot be empty at the same time;',
    THE_SIZE_OF_YOUR_UPLOADED_IMAGE_IS: 'The size of the image you uploaded is',
    THE_START_TIME_CANNOT_BE_LESS_THAN_THE_FILING_DATE: 'The start time cannot be less than the filing date;',
    THE_STATISTICAL_DATE_CANNOT_BE_GREATER_THAN_THE_CURRENT_DATE: 'The statistical date cannot be greater than the current date',
    THE_STATISTICAL_DATE_CANNOT_BE_LESS_THAN_THE_FILING_DATE: 'The statistical date cannot be less than the filing date',
    THE_STOCK_QUANTITY_CANNOT_BE_EMPTY: 'In stock quantity cannot be empty',
    THE_STORE_DIMENSION_INPUT_VALUE_IS_INCORRECT: 'The store dimension input value is wrong;',
    THE_STORE_DOES_NOT_EXIST: 'The store does not exist;',
    THE_STORE_LANGUAGE_TYPE_DOES_NOT_EXIST: 'Store language type does not exist;',
    THE_STORE_MAILBOX_INPUT_VALUE_IS_INCORRECT: 'Do not delete in used vendor category',
    THE_SUPERIOR_CLASSIFICATION_DOES_NOT_EXIST: 'The parent category does not exist;',
    THE_SUPPLIER_CATEGORY_BEING_USED_CANNOT_BE_DELETED: 'The vendor category is in used and cannot be deleted!',
    THE_SUPPLIER_DOES_NOT_EXIST: 'Number of days must be numeric',
    THE_TOTAL_NUMBER_OF_DAYS_FOR_THE_TEMPLATE_STORE_MUST_BE_GREATER_THAN_0: 'Template total number of days in store project must greater than 0',
    THE_TOTAL_NUMBER_OF_DAYS_IN_THE_TEMPLATE_STORE_MUST_BE_A_NUMERIC_TYPE: 'Template total number of days in store project must in number format',
    THE_TRACKING_NUMBER_OF_THE_ITEM_ALREADY_EXISTS: 'The tracking code of the item already exists;',
    THE_UPLOAD_DIRECTORY_DOES_NOT_EXIST: 'The upload directory does not exist.',
    THE_UPLOAD_DIRECTORY_DOES_NOT_HAVE_WRITE_PERMISSION: 'The upload directory does not have write permission.',
    THE_UPLOAD_FILE_SIZE_EXCEEDS_THE_LIMIT: 'The upload file size exceeds the limit.',
    THE_UPPER_CLASSIFICATION_HAS_DUPLICATE_DATA: 'The parent category has duplicate data;',
    THE_USER_ALREADY_HAS_THE_POSITION: 'The position already exists for the user;',
    THE_USER_ENTERED_THE_MAILBOX_INCORRECTLY: 'The bind email entered by the user is incorrect;',
    THE_USERS_WORK_MAILBOX_INPUT_VALUE_IS_INCORRECT: 'The work email entered by the user is incorrect;',
    THE_VALUE_ENTERED_ON_THE_SHOP_OPENING_DATE_IS_INCORRECT: 'The store opening date was entered incorrectly;',
    THE_VALUE_OF_THE_LAST_RENOVATION_DATE_IS_INCORRECT: 'The last renovation date is incorrect;',
    THE_WORD_COUNT_EXCEEDS_200_WORDS: 'The word count exceeds 200 words;',
    THE_WRONG_ITEM_CLASSIFICATION_LEVEL_IS_SELECTED: 'The wrong prop category level is selected',
    THE_YEAR_OF_BIRTH_CANNOT_EXCEED_THE_CURRENT_YEAR: 'The birth year cannot exceed the current year;',
    THERE_ARE_NO_COMMODITIES_UNDER_THE_CATEGORY: 'There are no products under the major category;',
    THERE_IS_DUPLICATE_DATA_IN_EXCEL: 'There is duplicate data in Excel;',
    THERE_IS_NO_SUCH_CHANNEL_NUMBER_UNDER_THE_STORE: 'There is no such channel code under the store;',
    THERE_IS_NO_SUCH_SUBCATEGORY_UNDER_THE_BIG_CATEGORY: 'There is no such category under the major category;',
    THIS_ALREADY_EXISTS_IN_EXCEL: 'This already exists in Excel;',
    THIS_BRAND_HAS_BEEN_ASSIGNED_A_STORE_AND_CANNOT_BE_DELETED: 'This brand has been assigned a store and cannot be deleted',
    THIS_FUNCTION_DOES_NOT_SUPPORT_FOLDERS: 'Folder function is not supported',
    THIS_FUNCTION_IS_ONLY_SUPPORTED_FOR_THE_SUPPLIER_WHOSE_SERVICE_TYPE_IS_SHOP_REPAIR: 'This function is only supported for the supplier whose service type is store maintenance',
    THIS_ITEM_CANNOT_ADD_ORGANIZATION: 'This item cannot be added to the organization',
    THIS_POSITION_DOES_NOT_EXIST: 'This position does not exist;',
    THIS_PRODUCT_IS_USED_AND_CANNOT_BE_DELETED: 'This product is used and cannot be deleted',
    THIS_USER_DOES_NOT_EXIST: 'This user does not exist;',
    THRESHOLD: 'Threshold',
    THRESHOLD_MODE: 'Threshold mode',
    THRESHOLD1: 'Threshold',
    THURSDAY: 'Thursday',
    TICKETS: 'Unit per Transaction',
    TIME: 'Time',
    TITLE: 'Title',
    TITLE_CONTENT: 'Subject content',
    TITLE_DESCRIPTION: 'Subject description',
    TITLE_DETAILS: 'Subject details',
    TITLE_PICTURE: 'Subject image',
    TITLE1: 'Subject name',
    TO: 'To',
    TO1: 'To',
    TOTAL_NUMBER_OF_DAYS_WITH_TEMPLATE_SHOP: 'Template total number of days in store project',
    TOTAL_NUMBER_OF_MATTERS: 'Update completed',
    TOTAL_NUMBER_OF_STAGES: 'Number of phases',
    TOTAL_PASSENGER_FLOW: 'Total customer flow',
    TOTAL_SALES: 'Total sales',
    TOTAL_SALES_AMOUNT: 'Total sales amount',
    TOTAL_SCORE_IS_SHOWN_AS: 'Total score is shown as',
    TOTAL_TRANSACTION: 'Total transaction',
    TOTAL_TRANSACTIONS: 'Total transaction',
    TRADITIONAL_CHINESE: 'Traditional Chinese',
    TRADITIONAL_CHINESE1: 'Chinese Traditional',
    TRANSFER_RECORD_CATEGORY: 'Daily log record category',
    TRANSFER_THIS_CATEGORY: 'Daily log category',
    TREE_MENU_BASIC_DATA: 'Basic data',
    TURN_ON: 'Open',
    TURN_ON_THE_WATERMARK_ON_THE_SCREEN_OF_THE_MOBILE_PHONE: 'Turn on the watermark on the screen of the mobile phone',
    TURN_ON_TOP_SORT: 'Enable order by sticky item',
    TURNOVER: 'Turnover',
    TYPE_CONVERSION_FAILED_TYPE_CANNOT_BE_CONVERTED: 'Type conversion failed and cannot be converted:',
    TYPE_ENCODING: 'Type code',
    TYPE_ENGLISH_NAME: 'Type name',
    TYPE_ID: 'Type ID',
    TYPE_INFORMATION: 'Type information',
    TYPE_NAME: 'Type name',
    TYPE_NUMBER: 'Type code',
    TYPE_OPERATION: 'Type operation',
    TYPES_OF: 'Type',
    UNFREEZE: 'Unfreeze',
    UNIT: 'Unit',
    UNIT_PRICE: 'Unit price',
    UNKNOWN_MISTAKE: 'Unknown error',
    UNKNOWN_MISTAKE1: 'Unknown error.',
    UNLIMITED: 'Unlimited',
    UNLIMITED_CATEGORIES: 'Unlimited categories',
    UNLIMITED_ORGANIZATION: 'Unlimited organizations',
    UNLOCKED: 'Unlocked',
    UNPIN: 'Cancel setting',
    UNQUALIFIED_SCORE: 'Unqualified Score',
    UNSPECIFIED: 'Unspecified',
    UNSUCCESSFUL: 'Unsuccessful',
    UNSUCCESSFUL_DATA: 'Unsuccessful data',
    UPDATE_COMPLETED: 'Update completed!',
    UPDATE_COMPLETED1: 'Update completed',
    UPDATE_DATA: 'Update data',
    UPDATE_FAILED: 'Update failed:',
    UPDATE_FAILED1: 'Update failed',
    UPDATE_FAILED2: 'Update failed!',
    UPDATE_MULTILINGUAL: 'Update multi-language',
    UPLOAD: 'Upload',
    UPLOAD_ATTACHMENT: 'Upload file',
    UPLOAD_DATE: 'Upload date',
    UPLOAD_FAILED: 'Upload failed',
    UPLOAD_FAILED1: 'Upload failed',
    UPLOAD_FAILED2: 'Upload failed',
    UPLOAD_FILE_NOT_FOUND: 'Upload file not found',
    UPLOAD_FILES: 'Upload files',
    UPLOAD_IMAGE: 'Upload image',
    UPLOAD_INFORMATION: 'Upload information',
    UPLOAD_LIMIT: 'Upload limit!',
    UPLOAD_OF_STORE_ATTACHMENT_FAILED: 'Upload store attachment failed',
    UPLOAD_SHOP_ATTACHMENT: 'Upload store attachment',
    UPLOAD_TIME: 'Upload time',
    UPLOAD_TRAINING_MATERIALS: 'Upload training materials',
    UPLOADED_BY: 'Uploaded by',
    UPLOADED_DATA_EXCEEDS: 'Uploaded data exceeds',
    UPLOADED_SUCCESSFULLY: 'Uploaded successfully',
    UPLOADING_TRAINING_MATERIALS_FAILED: 'Upload training materials failed',
    USE_DETAILS: 'Usage details',
    USER: 'User',
    USER_AGREEMENT: 'User agreement',
    USER_AGREEMENT_UPLOAD: 'User agreement upload',
    USER_CANCELED_OPERATION: 'Operation cancelled by user',
    USER_DATA_IMPORT: 'Import user data',
    USER_ID: 'User ID',
    USER_JOB_INFORMATION_IMPORT: 'Import user position data',
    USER_REFERENCE: 'User reference',
    USER_REFERENCE_IN_USE_CANNOT_BE_DELETED: 'User reference in use and cannot be deleted!',
    USER_TYPE: 'User type',
    ExcelTemplate_common_000013: 'User type',
    USERNAME: 'Username',
    USERS_IN_EXCEL_CANNOT_REPEAT_THE_SAME_POSITION: 'Users in Excel cannot repeat the same position;',
    VALID_UNTIL: 'Valid until',
    VALUE: 'Value',
    VALUE_ELEMENT: 'Element attribute',
    VENDOR_TYPE_NAME: 'Vendor type name',
    VENDOR_TYPE_NUMBER: 'Vendor type code',
    VERIFICATION_CODE: 'Verification code',
    VIEW: 'View',
    VIEW_REPAIR_CODE: 'View maintenance code',
    VIEW_SERVICE_CODE: 'View service code',
    VISUAL_DISPLAY: 'VM management',
    m_info_common_000020: 'VM Management',
    VISUAL_DISPLAY_RECORD: 'Record',
    VOIP_CALL_HISTORY: 'VOIP call history',
    WAREHOUSE: 'Warehouse',
    WAREHOUSE_IN_THIS_ISSUE: 'Stock in',
    WEATHER_CODE: 'Weather code',
    WEEK: 'Week',
    WEIGHTS: 'Weights',
    WEIGHTS1: 'Weights',
    WELCOME_STRING: 'Hello',
    WELCOME_STRING1: 'You are logged in',
    WHETHER_ADMINISTRATOR: 'Is an administrator?',
    WHETHER_COMPLETED: 'Completed?',
    WHETHER_GIVEAWAY: 'Is it a free gift?',
    WHETHER_LOCKED: 'Lock',
    WHETHER_LOGIN_PROTECTION: 'Enable login protection?',
    WHETHER_PROJECT_MANAGER: 'Is a project manager?',
    WHETHER_SUCCEED: 'Successful?',
    WHETHER_THE_PROBLEM_DESCRIPTION_IS_REQUIRED: 'Is the question description required?',
    WHETHER_THE_SUPPLIER_INSTALLS: 'Need to install by vendor?',
    WHETHER_TO_CONFIRM_THE_REPAIR_CODE: 'Are you sure you want to restore maintenance code',
    WHETHER_TO_CONNECT: 'Are you sure you want to connect?',
    WHETHER_TO_ENABLE: 'Need to enable?',
    WHETHER_TO_MODIFY_THE_SCORE_MUST_NOT_BE_EMPTY: 'Allow to modify score cannot be empty;',
    WHETHER_TO_SELL: 'Are you sure you want to sell?',
    WHETHER_TO_STICK: 'Are you sure you stick this item?',
    WITHOUT_THE_MANUAL_ID: 'No manual ID',
    WITHOUT_THE_PRIMARY_KEY_ID: 'No primary key ID',
    WORK_EMAIL: 'Email',
    WORK_INFO: 'Work information',
    WORK_SHOP_WITH_SHOP_TEMPLATE: 'Store project template',
    WORKING_ADDRESS: 'Work address',
    WORKING_AGE: 'Length of service',
    WRONG_BIRTHDAY_FORMAT: 'Invalid birthday format',
    YEAR: 'Year',
    YEAR_OF_BIRTH: 'Year of Birth',
    YES: 'Yes',
    YOU_ARE_NOT_USING_IE8_OR_ABOVE_IT_MAY_CAUSE_COMPATIBILITY_PROBLEMS_AND_PREVENT_YOU_FROM_USING_IT_NORMALLY: 'Kindly update your browser to latest version to prevent any compatibility issues to the system.',
    YOU_HAVE_NOT_SELECTED_A_NODE: 'You have not selected a node yet',
    YOU_HAVE_NOT_SELECTED_THE_PARENT_FOLDER: 'You have not selected the parent folder.',
    APPLY_FOR_REPAIRS: 'Submit an image for the maintenance application?',
    MUSTPROPACCEPTANCESCORE: 'Is the props acceptance score required?',
    MUSTPROPCONTENT: 'Is the props issue description required?',
    PROPACCEPTANCEIMGCOUNT: 'Props acceptance image configurations',
    PROPS_MODULE_CONFIGURATION: 'Props module configuration',
    HISTORICAL_RATE: 'Historical Rate',
    ADD_FAILED_THE_FORM_NAME_ALREADY_EXISTS: 'Add failed. The form name already exists',
    ADD_FORM: 'Add form',
    BOOLEAN: 'Boolean',
    CALCULATION_FORMULA: 'Calculation Formula',
    CATEGORY_DEFAULT_VENDOR_INVALID: 'The category limit you modified has cause the default vendor of the following categories invalid, please set it manually.',
    CHECKBOX: 'Checkbox',
    COMPANY: 'Company',
    CONTROL_DESCRIPTION: 'Control description',
    CONTROL_DESCRIPTION1: 'Control description',
    CONTROL_NAME: 'Control name',
    CONTROL_TYPE: 'Control type',
    COUNTRY_NUMBER: 'Country code',
    CURRENT_EXCHANGE_RATE: 'Current Exchange rate',
    CUSTOM_REFERENCE: 'Custom reference',
    DATA_IMPORT: 'Import data',
    DATE_CONTROL: 'Date control',
    DATE_TYPE: 'Date type',
    DECIMAL_PLACES1: 'Decimal places',
    DEFAULTS: 'Default value',
    DELETE_FORM: 'Delete form',
    DROP_DOWN_BOX: 'Drop down box',
    ENUMERATION: 'enum',
    FILE_UPLOAD_CONTROL: 'File upload comtrol',
    FORM_DESCRIPTION: 'Form description',
    FORM_DETAILS: 'Form details',
    FORM_NAME: 'Form name',
    FORM_NAME_CONTAINS_ILLEGAL_CHARACTERS_ONLY_ALPHANUMERIC_AND_UNDERSCORES_ARE_ALLOWED: 'Invalid form name. Form name should contain only underscores and alphanumeric characters',
    FORM_TITLE: 'Form title',
    IF_YOU_DELETE_THE_TEMPLATE_ALL_THE_QUESTIONS_IN_THE_TEMPLATE_WILL_BE_DELETED_TOGETHER_ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT: 'If you delete the template, all the questions in the template will be deleted together. Are you sure you want to delete it?',
    IMPORT_FORM: 'Import form',
    INPUT_CHARACTERS_DO_NOT_MEET_REQUIREMENTS: 'Input characters do not meet requirements',
    IS_EMPTY: 'Allow empty?',
    MAX: 'Max',
    MINIMUM_VALUE: 'Min',
    NO_PICTURE: 'No image',
    NOTE_CURRENTLY_ONLY_SUPPORTS_XLS_FORMAT: 'Note: Only support .xls format only',
    OPTIONAL_ROLE: 'Optional role',
    PICTURE_UPLOAD_CONTROL: 'Image upload control',
    PRIORITY_HIGHLIGHTING: 'Priority highlight',
    PUBLISHED_SUCCESSFULLY: 'Released successfully',
    REFERENCE_TYPE: 'Reference type',
    RELEASE: 'Release',
    SELECTED_ROLES: 'Selected Roles',
    SEQUENCE: 'Order',
    STANDARD_MODE1: 'Standard mode (sum of all entries)',
    STORE_INFO: 'Store information',
    SYSTEM_REFERENCE: 'System reference',
    TASK_CENTER: 'Task center',
    TEXT_BOX: 'Text box',
    THE_MAXIMUM_AND_MINIMUM_RANGE_IS_2147483648_TO_2147483647: 'The maximum and minimum values range from - 2147483648 to 2147483647',
    THE_MAXIMUM_LENGTH: 'The maximum length',
    THRESHOID_MODE1: 'Threshold mode (according to the score of sub items, determine whether the major categories meet the standard)',
    TIME_CONTROL: 'Time range',
    TIME_TYPE: 'Time type',
    TOUR_CATEGORY: 'Checklist category',
    TYPE_OF_DATA: 'Data type',
    UPDATE_TIME: 'Update time',
    WHETHER_TO_ALLOW_NULL: 'Allow empty?',
    WHETHER_TO_DISPLAY_THE_LIST: 'Display list?',
    WHETHER_TO_SHOW: 'Display?',
    WORK_SHOP_WITH_SHOP: 'Store project',
    r_info_common_000022: 'Open store',
    d_info_common_000022: 'Open store',
    YZAPPID: 'YZAPPID',
    z_info_common_000001: 'Serial number cannot be duplicated',
    z_info_common_000004: 'Completion settlement is mandatory',
    z_info_common_000009: 'Re-dispatch engineer',
    z_info_common_000010: 'Acceptance reminder',
    z_info_common_000011: 'User comments',
    z_info_common_000012: 'Cancel order',
    z_info_common_000013: 'Maintenance application completed ',
    z_info_common_000014: 'Re-dispatch (Select engineer)',
    z_info_common_000015: 'Pending maintenance application',
    z_info_common_000016: 'Add new maintenance application',
    z_info_common_000017: 'One-click reminder',
    z_info_common_000018: 'Generate orders',
    z_info_common_000019: 'Reject maintenance plan',
    z_info_common_000020: 'Acceptance failed',
    z_info_common_000021: 'Acceptance deadline reminder',
    z_info_common_000022: 'Re-dispatch (Enter information)',
    z_info_common_000023: 'Submit maintenance plan',
    z_info_common_000024: 'Reject maintenance plan',
    z_info_common_000025: 'Dispatch deadline reminder',
    z_info_common_000026: 'Returned for repair Email',
    z_info_common_000027: 'Cancel maintenance application',
    z_info_common_000028: 'Return',
    z_info_common_000029: 'Accepted',
    z_info_common_000030: 'Orders completed',
    z_info_common_000031: 'Maintenance application review',
    z_info_common_000032: 'Maintenance plan confirmation',
    z_info_common_000033: 'Price enquiry',
    z_info_common_000034: 'Submit completion settlement',
    z_info_common_000035: 'Confirm completion settlement',
    z_info_common_000036: 'Reject completion settlement',
    z_info_common_000037: 'Startup maintenance project',
    z_info_common_000038: 'User information not found',
    z_info_common_000039: 'The account has been deleted. Do you want to restore previous records?',
    z_info_common_000040: 'Restore account',
    z_info_common_000041: 'Add new account',
    z_info_common_000042: 'Please select account you need to restore ',
    z_info_common_000043: 'Please select the position of the account to be restored',
    z_info_common_000044: 'Deleted record',
    z_info_common_000006: 'Store language',
    z_info_common_000007: 'Default currency',
    z_info_common_000008: 'GPS',
    USER_ADDED_SUCCESS_MESSAGE: 'The account number and initial password have been sent to the user via SMS',
    z_info_common_000045: 'Props management setting',
    z_info_common_000046: 'Allow auto-completion?',
    z_info_common_000047: 'After self acceptance',
    z_info_common_000048: 'Allow replenish',
    z_info_common_000049: 'Day',
    z_info_common_000050: 'Camera information',
    z_info_common_000051: 'Platform type',
    z_info_common_000052: 'Access type',
    z_info_common_000053: 'Camera code',
    z_info_common_000054: 'Device serial number',
    z_info_common_000055: 'Region',
    z_info_common_000056: 'Camera Name',
    z_info_common_000057: 'Camera link',
    z_info_common_000058: 'Channel number',
    z_info_common_000059: 'Device verification code',
    z_info_common_000060: 'Camera management',
    z_info_common_000061: 'Multiple binding of the same store is not allowed for the same camera',
    z_info_common_000062: 'Camera number cannot be repeated',
    z_info_common_000063: 'Link address of the camera live broadcast that playable in Link mode',
    z_info_common_000064: 'Platform APPkey. Please refer to the official website for application',
    z_info_common_000065: 'Platform AppSecret. Please refer to the official website for application',
    z_info_common_000066: 'Serial number on device',
    z_info_common_000067: 'Device verification code, six uppercase letters on the device body',
    z_info_common_000068: 'Hire date',
    z_info_common_000069: 'Closed',
    z_info_common_000070: 'Email cannot be repeated, please fill in again',
    z_info_common_000072: 'Please remove the binding relationship of the maintenance category first',
    z_info_common_000071: 'Please remove the binding relationship of the maintenance fault first',
    z_info_common_000073: 'Issue category cannot be repeated',
    z_info_common_000074: 'Display position',
    z_info_common_000075: 'Store delivery',
    z_info_common_000076: 'Country/ Region',
    z_info_common_000077: 'Closing time',
    z_info_common_000078: 'Hire date format is wrong',
    z_info_common_000079: 'Closing time cannot later than current time',
    z_info_common_000080: 'Organization category not exist',
    z_info_common_000081: 'Apply for withdrawal',
    z_info_common_000082: 'Allow to apply for unstocked items',
    z_info_common_000083: 'Currently only supports public folders, online training, role configuration',
    z_info_common_000084: 'Only view roles of the same organization type',
    z_info_common_000085: 'Public folders configuration',
    z_info_common_000086: 'Closed store time format is wrong',
    z_info_common_000087: 'Normal',
    z_info_common_000088: 'Sorting configuration',
    'z_info_common_000089\t': 'Sent, please wait',
    z_info_common_000090: 'Batch disabled',
    z_info_common_000091: 'Show disabled',
    z_info_common_000092: 'Are you sure to stop?',
    PLEASE_ENTER_ACCOUNT: 'Please enter account number',
    ACCOUNT_PASSWORD_CANNOT_EMPTY: 'Account password cannot be empty! Please re-enter',
    InfoAccountCannotEmpty: 'Account number cannot be empty! Please re-enter',
    InfoPleaseSelectCompany: 'Select company',
    InfoYourPasswordIsEmpty: 'Please re-enter password',
    InfoLogOut: 'Logout',
    ImportOrExport: 'Import/ Export',
    SearchedOut: 'Search',
    Results: 'Results',
    Operation: 'Operation',
    Edit: 'Edit',
    TurnIntoShop: 'Convert to store',
    Filter: 'Filter',
    PleaseEnter: 'Please enter',
    DeleteSelectOrganization: 'Do you want to delete the selected organization?',
    DeletionCancelled: 'Cancel deletion',
    Return: 'Return',
    SelectOrganization: 'Select organization',
    NewOrganization: 'New organization',
    EditOrganization: 'Edit organization',
    NoSelectMsg1: 'It is not allowed to choose yourself and the organization below yourself as the parent organization',
    EditSuccess: 'Edit successfully!',
    InfoStoreStatus: 'Store status',
    InfoIsDeleteStore: 'Do you want to delete the selected store?',
    InfoSelectTimeRange: 'Choose time range',
    InfoMustContain: 'Must contain @ sign',
    InfoServerBusy: 'Server busy',
    InfoDataNoExist: 'Data does not exist',
    InfoNoLoginRights: 'You do not have login rights, please contact the administrator',
    InfoSubmitFailed: 'Submission Failed',
    InfoCreationFailed: 'Creation failed',
    InfoUpdateFailed: 'Update failed',
    InfoAgainLogin: 'Your login has expired, please log in again',
    InfoInvalidEnterpriseWechatAuthcode: 'Wecom AuthCode is invalid',
    InfoAccountNoExist: 'The account you entered does not exists, please contact your Administrator',
    InfoCompanyDeleted: 'The company has been deleted, please contact R+ administrator',
    InfoCompanyFrozen: 'The company has been frozen, please contact R+ administrator',
    InfoUserDeleted: 'User has been deleted',
    InfoUserFrozen: 'User has been frozen',
    InfoNotSystemAdministrator: 'Sorry, you are not the system administrator, please contact the administrator',
    InfoPasswordError: 'Sorry, your password is incorrect, please re-enter',
    InfoCompanyExpired: 'Company has expired',
    InfoNameAlreadyExists: 'Name already exists',
    InfoOrganizationTypeNoExist: 'Organization type does not exist',
    InfoSuperiorOrganizationNoExist: 'The parent organization does not exist',
    InfoStoreNoExist: 'Store not exist',
    InfoStoreOrganizationNoExist: 'Store organization does not exist',
    InfoStoreCodeAlreadyExists: 'Store code already exists',
    InfoStoreExistingPosition: 'Positions exist in store',
    InfoOrganizationExistingPosition: 'Positions exist in organization',
    InfoSubsetsOrganizations: 'Subset organization',
    InfoOrganizationTypeIsShop: 'Organization type is store',
    InfoOrganizationTypeNotModified: 'Organization type cannot be modified',
    InfoWechatSynchronization: 'The organization synced by WeChat is not allowed to be deleted',
    InfoUnauthorized: 'Unauthorized, please log in again',
    InfoAccessDenied: 'Access denied',
    InfoRequestError: 'Request error, the resource was not found',
    InfoRequestMethodNoAllowed: 'Request method not allowed',
    InfoRequestTimeout: 'Request timeout',
    InfoServerSideError: 'Server-side error',
    InfoNetworkNoImplemented: 'Network not implemented',
    InfoNetworkError: 'Network Error',
    InfoServiceNoAvailable: 'Service not available',
    InfoNetworkTimeout: 'Network connection could not establish',
    InfoNoSupportedRequest: 'http version does not support the request',
    InfoServerResponseTimeout: 'Server response timed out, please refresh the current page',
    InfoConnectServerFailed: 'Connection failure',
    z_info_common_000093: 'Store Longitude',
    z_info_common_000094: 'Store Latitude',
    z_info_common_000095: 'Last Renovation Date',
    z_info_common_000096: 'Available time for maintenance',
    z_info_common_000097: 'Operating Hour',
    z_info_common_000098: 'Closing Hour',
    z_info_common_000099: 'Floor Plan Title',
    z_info_common_000100: 'Floor Plan File Location',
    z_info_common_000101: 'Max. characters of store code is 12;',
    z_info_common_000102: 'Status (Normal: 0, Closed: 1)',
    z_info_common_000103: 'Only allow input 0 or 1 as status',
    infoapi_common_000001: 'China',
    infoapi_common_000002: 'US/ Canada',
    infoapi_common_000003: 'Russia',
    infoapi_common_000004: 'Peru',
    infoapi_common_000005: 'Brazil',
    infoapi_common_000006: 'Australia',
    infoapi_common_000007: 'Indonesia',
    infoapi_common_000008: 'Philipines',
    infoapi_common_000009: 'New Zealand',
    infoapi_common_000010: 'Singapore',
    infoapi_common_000011: 'Thailand',
    infoapi_common_000012: 'Japan',
    infoapi_common_000013: 'Korea',
    infoapi_common_000014: 'Myanmar',
    infoapi_common_000015: 'Hong Kong',
    infoapi_common_000016: 'Macau',
    infoapi_common_000017: 'Taiwan',
    RESETCancelled: 'Reset cancelled',
    BATCH_SET: 'Batch operations',
    SET_LABEL: 'Set label',
    Note_WXSYNCHROHIZATION_LABEL: 'Note: * represents the label synchronized by Wecom',
    Note_COMMON_LABEL: 'Note: xxx stores are currently selected, this page only displays and maintains the common tags of these stores',
    NEW_LABEL: 'Add label',
    IS_RETURN_STORE: 'Are you sure to convert the current organization to a store',
    TurnIntoOrg: 'Convert to organization',
    IS_RETURN_ORG: 'Are you sure to restore the store to an organization?',
    SUCCESSFULLY_REDUCTION: 'Restored successfully',
    SUCCESSFULLY_TRANSFORMATION: 'Successful conversion',
    Is_Enterprise_Micro_Synchronization: 'Synchronize from Wechat Work',
    Latest_Login_Time: 'Latest login time',
    Position_Information: 'Job information',
    No_ADMINISTRATOR: 'Non administrator',
    Open: 'Open',
    Not_Open: 'Not open',
    Lock_In_People: 'Lock staff',
    Unbundling: 'Unbind',
    Binding: 'Binding',
    Retail_Manager: 'Retail Manager',
    Store_Manager: 'Store manager',
    Store_Staff: 'Store staff',
    Non_Retail_System: 'Non retail system',
    Vacation: 'Vacation',
    InfoIsDeletePerson: 'Do you want to delete the selected person?',
    CurrentDefaultPosition: 'Current default position',
    SetDefaultPosition: 'Set default position',
    DefaultPosition: 'Default position',
    DefaultPositionChangeTo: 'Change default position to',
    MAIL_NOTIFICATION: 'Mail nitification',
    UnorganizedConvertedStores: 'Non-organized conversion store',
    OrganizationSubordinateOrganizations: 'Sub-organization',
    EnterpriseSynchronizationOnly: 'Only organizations that are synchronized with Wecom can be converted',
    AccountAlreadyExists: 'Account already exists',
    WorkMailboxAlreadyExists: 'Work mailbox already exists',
    PersonnelDoesNotExist: 'Person does not exist',
    SEND_SMS_NOTIFICATION: 'Send SMS notification',
    SEND_MAIL_NOTIFICATION: 'Send mail notification',
    RELEVANT_PERSONNEL: 'Related personnel',
    BIND_ROLE: 'Bind role',
    DELETE_LABEL: 'Delete label',
    SELECTED_LABEL_HAVE_ROLE_OR_PERSON_ISDELETE: 'The selected label has a bound role/person, are you sure to delete it?',
    SELECTED_LABEL_HAVE_STORE_ISDELETE: 'There are bound stores under this label. Please confirm whether to delete them?',
    PERSON_LABEL: 'Person tag',
    LABEL_NAME_ALREADY_EXISTS: 'Tag name already exist',
    LABEL_DOES_NOT_EXIST: 'Tag does not exists',
    LABEL_MANAGEMENT: 'Tag management',
    SHOP_COVER: 'Store cover',
    UPLOAD_COVER: 'Upload cover',
    DELETE_COVER: 'Delete cover',
    PICTURE_CAPTURE: 'Screenshot',
    PLEASE_SELECT_CORRECT_PICTURE_FORMAT: 'Please choose the correct picture format!',
    NOTE_CURRENTLY_SELECTED: 'Note: currently selected',
    SHOP_PAGE_ONLY_SHOW_AND_MAINTAIN_COMMON_TAGS: 'This page only displays and maintains the common tags of these stores',
    QW_BIND_STATUS: 'Wecom binding status',
    STORE_FLOOR_PLANS: 'Store floor plans',
    UPLOAD_FLOOR_PLAN: 'Upload floor plan',
    FLOOR_PLAN_NAME: 'Floor plan name',
    LOOK_FLOOR_PLAN: 'Check floor plan',
    CLICK_UPLOAD: 'Click to upload',
    ONLY_UPLOAD_JPG_OR_PNG_FILE: 'Only upload jpg/png files',
    PLEASE_UPLOAD_A_2000_2000_PIXEL_IMAGE: 'Please upload picture within 2000*2000 pixels!',
    CHOICE_DATE: 'Select date',
    PLEASE_BEFORE_SELECT_ORGANIZATION: 'Please select organization',
    NOTE_OLD_ORGANIZATION_NAME: 'Note: Original organization name',
    RETURN_FOR_ORG: 'Revert to organization',
    THE_ORG_NO_ALLOW_TURN_SHOP: 'The organization does not allow convert to store',
    ExcelTemplate_common_000001: 'Organization ID',
    ExcelTemplate_common_000002: 'Organization Name',
    ExcelTemplate_common_000003: 'Parent Organization ID',
    ExcelTemplate_common_000004: 'Parent Organization Name',
    ExcelTemplate_common_000005: 'Organization Type',
    ExcelTemplate_common_000006: 'Synchronize from Wechat Work',
    ExcelTemplate_common_000007: 'Remark',
    CHECKED: 'Selected:',
    CHECKED_PERSON: 'Selected Persons:',
    CHECKED_STORE: 'Selected Stores :',
    DEVICE_MANAGEMENT: 'Device Management',
    MECHANICAL_ARM: 'Mechanical Arm',
    Equipment_Number: 'Device Code',
    Device_Type: 'Device Type',
    Device_SN: 'Device SN',
    Intranet_IP: 'LAN IP',
    ARM_BRAND: 'Brand',
    MODEL: 'Model',
    Installation_POSITION: 'Installation Position',
    CUSTOMER: 'Customer',
    INTERNET_IP: 'WAN IP',
    STATE: 'Status',
    LAST_USE_TIME: 'LastUsed Time',
    OFFLINE: 'Offline',
    ONLINE: 'Online',
    DEVICE_INFO: 'Device Info',
    z_info_common_000104: 'Status (Disable:0, Active:1)',
    TEST_QUESTION: 'Exam Question',
    DISPLAY_BROCHURE_RELATIONSHIP: 'VM Manual Relationship',
    ITEM_INVENTORY: 'Inventory',
    KPI_SALES_TARGET: 'KPI Sales Target',
    FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL: 'The format of the imported file is incorrect! Please upload a valid Excel file.',
    FILE_ALREADY_UPLOAD_YOU_CAN_VIEW_IMPORT_ASSISTANT: 'The file has been uploaded, you can view the data import results in the import assistant',
    BUSINESS_HOURS_OPENING: 'Business Hour (Open)',
    BUSINESS_HOURS_CLOSE: 'Business Hour (Close)',
    LABLE_ABOUT_PERSON: 'Label "xxx" related personnel',
    LABLE_ABOUT_STORE: 'Label "xxx" related store',
    TYPE_NAME_ALREADY_EXISTS: 'This type already existed',
    TYPE_IS_BEING_NOT_ALLOWED_DELETE: "You can't delete the type that already used",
    NO_DATA_DELETE: 'No data can be deleted',
    SET_DEFAULT: 'Set as Default',
    worker_common_000015: 'Corporate',
    worker_common_000016: 'Wholesale',
    infoapi_common_000019: 'Wholesale',
    SUPERIOR_NAME: 'Superior Name',
    SUPERIOR_ACCOUNT: 'Superior Account',
    ORG_TYPE_CANNOT_SET_ENTERPRISE_DEPARTMENT_STORE: 'Organization type cannot set as Enterprise, Department or Store',
    DEPARTMENT: 'Department',
    worker_common_000001: 'Organization type cannot be empty;',
    worker_common_000002: 'When adding an organization, the organization type cannot be Enterprise or Store',
    worker_common_000003: 'Superior organization ID cannot be empty',
    worker_common_000004: 'Superior organization ID format error',
    worker_common_000006: 'Organization type does not exist；',
    worker_common_000007: 'Superior organization does not exist;',
    worker_common_000010: 'Organization ID format error',
    worker_common_000011: 'Organization does not exist;',
    worker_common_000074: 'Organization does not exist;',
    worker_common_000012: 'Superior organization cannot be under subordinate organization;',
    worker_common_000013: 'When modifying the organization type, the original organization type set as Store cannot be updated;',
    worker_common_000014: 'When modifying the organization type, the original organization type set as Enterprise cannot be updated;',
    worker_common_000017: 'Normal',
    infoapi_common_000021: 'Normal',
    worker_common_000018: 'Closed',
    infoapi_common_000020: 'Store closed',
    worker_common_000019: 'When adding an organization, must set the Wecom synchronization field to N?',
    worker_common_000020: 'Store code cannot be empty;',
    worker_common_000021: 'Store name cannot be empty;',
    worker_common_000022: 'Store language cannot be empty;',
    worker_common_000023: 'Brand cannot be empty;',
    worker_common_000024: 'Currency cannot be empty;',
    worker_common_000025: 'Status cannot be empty;',
    worker_common_000026: 'Store ID format incorrect',
    worker_common_000027: 'Store ID does not exist;',
    worker_common_000028: 'Store Category does not exist;',
    worker_common_000035: 'The store type does not exist;',
    worker_common_000029: 'Superior organization ID does not exist;',
    worker_common_000030: 'Brand name does not exist;',
    worker_common_000031: 'Currency format incorrect;',
    worker_common_000032: 'Status format incorrect;',
    worker_common_000033: 'The closing time format is incorrect;',
    worker_common_000034: 'The closing time is incorrect;',
    worker_common_000036: 'Location does not exist;',
    worker_common_000037: 'The business type does not exist;',
    worker_common_000038: 'Business hours (Opening) time format is incorrect;',
    worker_common_000039: 'Business hours (Closing) time format is incorrect;',
    worker_common_000040: 'The store opening time must be earlier than the store closing time;',
    worker_common_000041: 'Floor plan title cannot be empty;',
    worker_common_000042: 'Floor plan file ID format error;',
    worker_common_000052: 'Floor plan file ID format error;',
    worker_common_000043: 'The store code already exists;',
    worker_common_000044: 'The store name already exists;',
    worker_common_000045: 'Duplicate store name in Excel;',
    worker_common_000046: 'Duplicate store code in Excel;',
    worker_common_000047: 'The length of the store code cannot exceed 12 characters;',
    worker_common_000048: 'The length of the store name cannot exceed 200 characters;',
    worker_common_000049: 'The length of the English name of the store cannot exceed 200 characters;',
    worker_common_000050: 'The store status is wrong;',
    worker_common_000051: 'The length of the floor plan title cannot exceed 2000 characters;',
    worker_common_000053: 'The length of the store address cannot exceed 300 characters;',
    worker_common_000054: 'Invalid store email format',
    worker_common_000055: 'The length of the store phone number cannot exceed 200 characters;',
    worker_common_000056: 'The length of the store contact person cannot exceed 200 characters;',
    worker_common_000057: 'The length of the store contact number cannot exceed 200 characters;',
    worker_common_000058: 'Name cannot be empty;',
    worker_common_000059: 'Account cannot be empty;',
    worker_common_000060: 'The length of the name cannot exceed 50 characters;',
    worker_common_000061: 'The length of the account cannot exceed 50 characters;',
    worker_common_000062: 'Role cannot be empty;',
    worker_common_000063: 'Organization cannot be empty;',
    worker_common_000064: 'User status cannot be empty;',
    worker_common_000065: 'The user status does not exist;',
    worker_common_000066: 'The user type does not exist;',
    worker_common_000067: 'The country does not exist;',
    worker_common_000068: 'Gender does not exist;',
    worker_common_000069: 'The start work date format is wrong;',
    worker_common_000070: 'The birthday format is wrong;',
    worker_common_000071: 'The birthday format is wrong;',
    worker_common_000072: 'Duplicate accounts in Excel;',
    worker_common_000073: 'The role does not exist;',
    worker_common_000075: 'UserID format error;',
    worker_common_000076: 'Duplicate accounts in the database;',
    worker_common_000077: 'The validity period format is incorrect;',
    worker_common_000078: 'The validity period must be greater than the current date;',
    worker_common_000079: 'User data not found;',
    worker_common_000080: 'Duplicate Email address in the database;',
    worker_common_000081: 'The role does not allow multiple users',
    worker_common_000082: 'The superior user does not exist;',
    ExcelTemplate_common_000014: 'Hire date',
    ExcelTemplate_common_000015: 'Superior Name',
    ExcelTemplate_common_000016: 'Superior Account',
    ExcelTemplate_common_000022: 'Country/ Region',
    infoapi_common_000018: 'Corporate',
    infoapi_common_000025: 'Retail management',
    infoapi_common_000026: 'Store management',
    worker_common_000083: {
      one: 'Duplicate shop ID in Excel',
      other: 'Duplicate shop IDs in Excel'
    },
    EXPORT_PEOPLE: 'Export Users',
    EXPORT_STAFF: 'Export User Authrizations',
    worker_common_000085: 'The same store name exists in the organization',
    worker_common_000086: 'ID data incorrect in the floor plan file',
    ExcelTemplate_common_000023: 'WeChat ID',
    worker_common_000088: 'The organization ID cannot be empty;',
    worker_common_000089: 'The role name cannot be empty;',
    worker_common_000091: 'Organization ID format is incorrect',
    worker_common_000094: 'Duplicate positions in Excel',
    ABOUT_PERSON: 'related personnel',
    ABOUT_STORE: 'related store',
    DOWNLOAD_POSITION_TEMPLATE: 'Download Authrization Template',
    IMPORT_PERSONNEL_POSITION: 'Import User Authrizations',
    ALLOW: 'Allow',
    NOT_ALLOW: 'Not allowed',
    NOT_EDIT_TYPE: 'The selected type cannot be changed',
    NOT_DELETE_TYPE: 'The selected type cannot be deleted',
    CURRENT_USER_TYPE_NOT_EDIT: 'The selected user type cannot be changed',
    ROLE_DATA_NOT_DELETE: 'Operation failure, the selected roles include data cannot be deleted',
    LEAEVE_NOT_OVER: 'Level of upper organization allow to view cannot over 7 level',
    ROLE_POSITION_IS_USE_NOT_DELETE: 'Operation failure,  the selected roles included used data',
    worker_common_000098: 'Invalid role ID',
    worker_common_000101: 'The role name cannot exceed 50 characters',
    worker_common_000102: 'Duplicate name of the same role in Excel',
    worker_common_000103: 'User type cannot be empty',
    worker_common_000104: 'Whether to allow invalid data for multiple users',
    worker_common_000105: 'The length of the remarks exceeds 300 characters',
    worker_common_000084: 'Currency is not activated;',
    currency_common_000001: 'The length of the {User name} cannot exceed {50} characters;',
    currency_common_000002: 'The length of the {User name} cannot less than {5} characters;',
    currency_common_000003: 'Invalid {User ID};',
    currency_common_000004: '{User name} cannot be empty;',
    currency_common_000005: '{User ID} format error;',
    currency_common_000006: 'The {User name} already exists;',
    currency_common_000007: '{User name} cannot be repeated;',
    currency_common_000008: '{User} does not exist;',
    UPDATE_ROLE_AUTHORITY_TITLE: 'The authorization setting of role "{xx}"',
    ALL_AUTHORITY: 'All authorizations',
    worker_common_000106: 'When importing and updating, the role and organization are not allowed to be modified. Please use the function of importing user role to modify the role of user;',
    infoapi_common_000032: 'Plan A',
    infoapi_common_000033: 'Plan B',
    infoapi_common_000034: 'Plan C',
    infoapi_common_000035: 'Issue tasks',
    infoapi_common_000036: 'Submit applications',
    OPEN_STORE_DESC: 'After opening the store, the store list will be open to everyone',
    OPEN_ADDRESS_BOOK_DESC: 'After opening the address book, the list of users is open to everyone',
    ALLOW_EXPORT_OF_CONTACTS_DESC: 'After opening, the information in the address book can be exported to the mobile phone address book',
    CHANGE_PASSWORD_AT_FIRST_LOGIN_DESC: 'After selecting it, the user who logs in for the first time must change the password',
    TURN_ON_THE_WATERMARK_ON_THE_SCREEN_OF_THE_MOBILE_PHONE_DESC: 'After selecting it, there will be watermark on the address book.',
    DEFAULT_PASSWORD_CONFIGURATION: 'Default password configuration',
    RANDOM_PASSWORD1: 'Random password',
    MODULE_COLOR: 'Module color',
    ONLY_RPLUS_QYWX: 'Only support R+ Work Wechat version',
    SYSTEM_DISTRIBUTION: 'System color',
    CUSTOM_COLOR_MATCHING: 'Custom color',
    RESTORE_DEFAULT_COLOR: 'Restore to default color',
    CLOPY_COLOR: 'Copy color',
    ADHESIVE_COLOR: 'Paste color',
    SUCCESS_COLOR: 'Successfully copied',
    z_info_common_000109: 'Allow to delete the checklist time',
    z_info_common_000110: 'day(s)',
    z_info_common_000111: 'Allow to delete reports',
    z_info_common_000112: 'Allowed time of deleting reports must between 1~999 days',
    INFO_TIPS_PERSON: 'The account already exists',
    ACCOUNT_HAVE_DELETE_INFO: 'This account has been deleted, please recover it if you need',
    BRAND_NO_DELETE_INFO: 'This brand has already been used in stores and cannot be deleted',
    SHOP_TEMPLETE_CONFIG: 'Checklist template setting',
    SHOP_TEMPLETE_CONFIG_DESC: 'After selecting it, the user will can preview the checklist report',
    BASIC_FIELD_CONFIG: 'Basic fields setting',
    CUSTOM_FIELD_CONFIG: 'Custom feilds setting',
    THE_ORG_NO_ALLOW_TURN_SHOP1: 'The organization has subordinate organizations and is not allowed to be converted into a store',
    NO_EDIT_TIPS: 'The role in Wecom synchronization is not allowed to be modified',
    WEEK_SET: 'Week setting (the first day of the week)',
    MECHANISM_CONTAINS_THE_WEEK_OF_JANUARY_1: 'Week including January 1st',
    MECHANISM_WEEK_CONTAINING_1_FIRST_THURSDAY: 'Week including the first Thursday',
    UPLOAD_LIMIT_WORD: 'Only Word format is supported and the file size cannot exceed 10M',
    ENLARGE: 'Zoom in',
    NARROW: 'Zoom out',
    TURN_LEFT: 'Rotate Left',
    TURN_RIGHT: 'Rotate Right',
    AGREEMENT_HAVE: 'Protocol already exists',
    WEEK_SET_1: 'Week setting',
    COST_RECORD: 'Cost record',
    PROJECT_MAINTENANCE: 'Maintenance project',
    PROBLEM_DESCRIPTION_REQUIRED: 'Problem description mandatory',
    ACCEPTANCE_SCORING_REQUIRED: 'Acceptance grade mandatory',
    VISIBLE_ROLE: 'visible roles',
    VISIBLE_REGIO: 'visible organizations',
    NO_LIMIT: 'no restrictions',
    SELECT_ORG: 'Select organization',
    ENABLE_CLASSIFICATION_PERMISSIONS: 'Enable category permissions',
    AUTO_SUCCESS: 'Auto-complete',
    PROP_APPLY_MIN_IMG_CONFIG: 'Prop application minimum image configuration',
    ACCEPTANCE_MIN_IMG_CONFIG: 'Minimum image acceptance configuration',
    ALLOW_REISSUE: 'Allow replenish',
    REPAIR_MAIL_CONFIG: 'Maintainence mail configuration',
    USER_STATUS_QUIT: 'Resigned',
    ORGANIZATION_PATH: 'Organization path',
    USER_HAS_RESIGNED: 'The user has been resigned',
    UPDATE_ORGANIZATION_PARENT_WARNING: 'After modifying the parent organization, it will no longer synchronize with Wecom',
    SMART_SCREEN: 'Smart Screen',
    SMART_SCREEN_ID: 'Smart Screen ID',
    SMART_SCREEN_LOCATION: 'Store',
    SMART_SCREEN_STATUS: 'Device status',
    SMART_SCREEN_REGISTERATION_DATE: 'Registration time',
    r_info_common_000001: 'Batch acceptance for prop',
    d_info_common_000001: 'Batch acceptance for prop',
    r_info_common_000002: 'Submit maintenance project',
    r_info_common_000003: 'Access prop analysis reports',
    d_info_common_000003: 'Access prop analysis reports',
    r_info_common_000004: 'Access maintenance analysis reports',
    d_info_common_000004: 'Access maintenance analysis reports',
    r_info_common_000005: 'Review defect repair application',
    d_info_common_000005: 'Review defect repair application',
    r_info_common_000006: 'Submit defect repair application',
    d_info_common_000006: 'Submit defect repair application',
    r_info_common_000007: 'Search defect repair application',
    d_info_common_000007: 'Search defect repair application',
    r_info_common_000008: 'Use defect repair',
    d_info_common_000008: 'Use defect repair',
    r_info_common_000009: 'Manage checklist plan',
    r_info_common_000010: 'View Sales report',
    d_info_common_000010: 'View Sales report',
    r_info_common_000011: 'Use Sales report',
    d_info_common_000011: 'Use Sales report',
    r_info_common_000012: 'Open trajectory',
    d_info_common_000012: 'Open trajectory',
    r_info_common_000013: 'View others’ follow-up maintenance',
    d_info_common_000013: 'View others’ follow-up maintenance',
    r_info_common_000014: 'Customer service headquarter _Nan Tong',
    d_info_common_000014: 'Customer service headquarter _Nan Tong',
    r_info_common_000015: 'Customer service headquarter _Ru Dong',
    d_info_common_000015: 'Customer service headquarter _Ru Dong',
    r_info_common_000016: 'Manage maintenance engineers',
    d_info_common_000016: 'Manage maintenance engineers',
    r_info_common_000017: 'Submit product maintenance application',
    d_info_common_000017: 'Submit product maintenance application',
    r_info_common_000018: 'Manage product maintenance',
    d_info_common_000018: 'Manage product maintenance',
    r_info_common_000019: 'Check users’ trajectory',
    d_info_common_000019: 'Check users’ trajectory',
    r_info_common_000020: 'View other‘s Open store project',
    d_info_common_000020: 'View other‘s Open store project',
    r_info_common_000021: 'Add Open store project',
    d_info_common_000021: 'Add Open store project',
    r_info_common_000023: 'View data report',
    d_info_common_000023: 'View data report',
    r_info_common_000024: 'Access report center',
    d_info_common_000024: 'Access report center',
    r_info_common_000025: 'Manage Sales Target',
    d_info_common_000025: 'Manage Sales Target',
    r_info_common_000026: 'Edit store profile',
    r_info_common_000027: 'Edit store profile',
    d_info_common_000027: 'Edit store profile',
    r_info_common_000028: 'Manage VM project',
    r_info_common_000029: 'Approve task plan',
    r_info_common_000030: 'View task plan',
    d_info_common_000030: 'View task plan',
    r_info_common_000031: 'Submit prop application unlimitedly',
    r_info_common_000032: 'Manage prop order',
    r_info_common_000033: 'View prop order',
    d_info_common_000033: 'View prop order',
    r_info_common_000034: 'Update props’s inventory',
    d_info_common_000034: 'Update props’s inventory',
    r_info_common_000035: 'View props’s inventory',
    d_info_common_000035: 'View props’s inventory',
    r_info_common_000036: 'Manage prop profiles',
    r_info_common_000037: 'Close prop application',
    d_info_common_000037: 'Close prop application',
    r_info_common_000038: 'Assign prop orders',
    r_info_common_000039: 'View all props',
    r_info_common_000040: 'Props acceptance',
    d_info_common_000040: 'Props acceptance',
    r_info_common_000041: 'Submit prop application',
    d_info_common_000041: 'Submit prop application',
    r_info_common_000042: 'Access prop application',
    d_info_common_000042: 'Access prop application',
    r_info_common_000043: 'Submit maintenance application unlimitedly',
    r_info_common_000044: 'Manage maintenance order',
    r_info_common_000045: 'View maintenance order',
    d_info_common_000045: 'View maintenance order',
    r_info_common_000046: 'Close maintenance application',
    d_info_common_000046: 'Close maintenance application',
    r_info_common_000047: 'Assign maintenance orders',
    r_info_common_000048: 'Maintenance acceptance',
    d_info_common_000048: 'Maintenance acceptance',
    r_info_common_000049: 'Submit maintenance application',
    d_info_common_000049: 'Submit maintenance application',
    r_info_common_000050: 'Access store maintenance',
    r_info_common_000051: 'Mailbox receives check list reports automatically',
    r_info_common_000052: 'Use Performance Evaluation',
    r_info_common_000053: 'Delete users',
    r_info_common_000054: 'Edit user profile',
    r_info_common_000055: 'Field Attendance',
    m_info_common_000016: 'Field Attendance',
    d_info_common_000055: 'Field Attendance',
    r_info_common_000056: 'Manage VM manual',
    r_info_common_000057: 'View VM pictures',
    d_info_common_000057: 'View VM pictures',
    r_info_common_000058: 'SubmitVM pictures',
    d_info_common_000058: 'SubmitVM pictures',
    r_info_common_000059: 'Reply for VM pictures',
    d_info_common_000059: 'Reply for VM pictures',
    r_info_common_000060: 'Access KPI graphs',
    r_info_common_000061: 'Access KPI graphs',
    d_info_common_000061: 'Access KPI graphs',
    r_info_common_000062: 'Use Daily Log',
    r_info_common_000063: 'Live video',
    m_info_common_000017: 'Live Video',
    r_info_common_000064: 'Input traffic data',
    d_info_common_000064: 'Input traffic data',
    r_info_common_000065: 'Manage task project',
    r_info_common_000066: 'Sumbit checklist report',
    r_info_common_000067: 'Use E-Learning',
    d_info_common_000067: 'Use E-Learning',
    r_info_common_000068: 'View all the documents within authority',
    r_info_common_000069: 'Input Sales data',
    d_info_common_000069: 'Input Sales data',
    r_info_common_000070: 'View other’s?unreviewed checklist reports',
    r_info_common_000071: 'Manage public files',
    r_info_common_000072: 'Access the Dashboard of Checklist',
    d_info_common_000072: 'Access the Dashboard of Checklist',
    r_info_common_000073: 'Use Mobile Learning',
    d_info_common_000073: 'Use Mobile Learning',
    r_info_common_000074: 'View other’s task group',
    r_info_common_000075: 'Add new customer',
    d_info_common_000075: 'Add new customer',
    r_info_common_000076: 'Manage Mobile Learning',
    d_info_common_000076: 'Manage Mobile Learning',
    r_info_common_000077: 'Manage bulletin board on App home page',
    d_info_common_000077: 'Manage bulletin board on App home page',
    r_info_common_000078: 'View hidden fields of store info',
    d_info_common_000078: 'View hidden fields of store info',
    r_info_common_000079: 'Manage task group plan',
    r_info_common_000080: 'Add new users',
    r_info_common_000081: 'Advantech IoT',
    d_info_common_000081: 'Advantech IoT',
    r_info_common_000082: 'Manage task group',
    r_info_common_000083: 'Set company progress',
    r_info_common_000084: 'Manage check list template',
    r_info_common_000085: 'Manage custom forms',
    d_info_common_000085: 'Manage custom forms',
    r_info_common_000086: 'View other‘s customer profiles',
    r_info_common_000087: 'View task group',
    r_info_common_000088: 'View checklist plan',
    d_info_common_000088: 'View checklist plan',
    r_info_common_000089: 'View calendar of store',
    d_info_common_000089: 'View calendar of store',
    r_info_common_000090: 'Add customised daily log',
    d_info_common_000090: 'Add customised daily log',
    m_info_common_000001: 'Custom form',
    m_info_common_000004: 'Props Management',
    m_info_common_000005: 'Task planning',
    m_info_common_000010: 'Rectification',
    m_info_common_000011: 'VM advanced module',
    m_info_common_000012: 'Dattemplate',
    m_info_common_000013: 'E-Leaning',
    m_info_common_000014: 'e-Working',
    m_info_common_000019: 'Checklist',
    m_info_common_000021: 'Daily Stock',
    m_info_common_000022: 'VOIP dial',
    m_info_common_000024: 'Park mall',
    m_info_common_000025: 'Follow Up',
    m_info_common_000027: 'Task group',
    m_info_common_000028: 'Product Maintenance',
    m_info_common_000031: 'Conference Call',
    m_info_common_000032: 'Mobile learning',
    m_info_common_000033: 'Retail Consultation',
    m_info_common_000034: 'KPI Chart',
    m_info_common_000037: 'eShop',
    m_info_common_000039: 'Advantech LoT',
    m_info_common_000040: 'Basic',
    d_info_common_000002: 'Submit maintenance project through “Batch Apply” on Web，submit  applications for multiple stores',
    d_info_common_000009: 'Release, edit and close checklist plan',
    d_info_common_000026: 'View other‘s （within the organization）VM project',
    d_info_common_000028: 'Add a VM project, release the requirements of the pictures, approve the pictures uploaded',
    d_info_common_000029: 'Approve tasks in a task plan',
    d_info_common_000031: 'Not subject to the limit of submit 1 request order in one day, and must accept within 7 days after delivery',
    d_info_common_000032: 'Manage maintenance order, confirm the delivery, close the order',
    d_info_common_000036: 'Add，edit，delete props',
    d_info_common_000038: 'Review prop application，assign orders to a vendor, including request re-delivery after acceptance',
    d_info_common_000039: 'View all information of the props of whole company on Web',
    d_info_common_000043: 'Not subject to the limit of submit 1 request order in one day, and must accept within 7 days after assignment',
    d_info_common_000044: 'Manage maintenance order , confirm the solution, price and report, close the order',
    d_info_common_000047: 'Review maintenance application，assign orders to a vendor,  including re-assignment after acceptance',
    d_info_common_000050: 'Access store maintenance',
    d_info_common_000051: 'Mailbox will receive checklist reports at the same time when the user is in the list of report recipients',
    d_info_common_000052: 'Use all functions of Performance Evaluation',
    d_info_common_000053: 'Delete users in same or below level',
    d_info_common_000054: 'Edit user profile in same or below level',
    d_info_common_000056: 'Upload and delete VM manuals, set the access permission',
    d_info_common_000060: 'Change the status of VM which store submitted freely',
    d_info_common_000062: 'View and reply in the daily log, and leave a new message',
    d_info_common_000063: 'Veiw the cameras remotely',
    d_info_common_000065: 'Release, edit and close task plan',
    d_info_common_000066: 'Use Checklist and sumbit checklist report',
    d_info_common_000068: 'View all the documents within "Me"→“My Report, including checklist report, checklist issues report, performance evaluation report',
    d_info_common_000070: 'View the unreviewed checklist reports (within?the organization)?waiting for others to review?',
    d_info_common_000071: 'Upload, edit and delete public files, set the access permission',
    d_info_common_000074: 'View other‘s （within the organization）task group',
    d_info_common_000079: 'Add, edit and delete task group plan',
    d_info_common_000080: 'Add new users in same or below level',
    d_info_common_000082: 'Add a task group, can edit and close the task group displayed',
    d_info_common_000083: 'Set company progress, including maintenance progress, prop apply progress',
    d_info_common_000084: 'Create and setting check list template on Web',
    d_info_common_000086: 'View other‘s （within the organization） customer profiles',
    d_info_common_000087: 'Whether show task group module',
    z_info_common_000113: 'Are you sure to convert to a new template?',
    SELECTED_ORGANIZATION_TO_STORE: 'Do you want selected organization be converted into a store?',
    SELECTED_ORGANIZATION_TO_STORE_FAIL: 'Organization convert to store failed',
    SELECTED_ORGANIZATION_TO_STORE_SUCCESS: 'Organization convert to store has been successful',
    ORGANIZATION_TO_STORE: 'Organization converted to store',
    SELECTED_ORGANIZATION_TO_STORE_INFO: '{0} {2} success, {1} cannot {2}',
    mntapi_common_000212: 'Request info',
    mntapi_common_000213: 'Issue info',
    CURRENT_POSITION: 'Displayed Position',
    ExcelTemplate_common_000024: 'DisplayPostion',
    COSTUMER_CODE: 'Client Code',
    COSTUMER_NAME: 'Client Name',
    UPDATED_BY: 'Updated by',
    COSTUMER_RELATION: 'Client Management',
    COSTUMER_RELATION_INFO: 'Client Information',
    Rebinding: 'Resync',
    Rebinding_MSG1: 'This operation will immediately synchronize its parent organization between R+ and Wechat Work. Are you sure?',
    SELECTED_OPERATION_FAIL: '{0} failed',
    SELECTED_OPERATION_SUCCESS: '{0} completed',
    Rebinding_MSG2: 'Resync is only for {0} that is bound to a department in Wechat Work, but is not fully synchronized.',
    SHOW_QY_USERNAME: 'Display name in Wechat Work',
    QY_USERNAME: 'Name in Wechat Work',
    SHOW_QY_DEPARTMENTNAME: 'Display department name in Wechat Work',
    QY_DEPARTMENTNAME: 'Dept. in Wechat Work',
    QY_CANNOT_GET: 'Unavailable',
    RETURN_ORG_MSG: 'The store information will be deleted, are you sure to delete it?',
    AREA_SETTING: 'Location setting',
    CLOSE_STORE_AND_RECOVER: 'Store closed / recovered',
    AREA_INFO: 'Location information',
    SELECT_AREA: 'Select location',
    AREA_NAME_EXISTS: 'Region name already exists',
    COSTUMER_NAME_EXISTS: 'Customer name already exists',
    COSTUMER_CODE_EXISTS: 'Customer code already exists',
    AREA_CODE_EXISTS: 'Location code already exists',
    FIELD_MANAGEMENT: 'Field management',
    STORE_FIELD_MANAGEMENT: 'Store field management',
    SAVE_FIELD: 'Save field',
    ADD_FIELD: 'Add field',
    ADD_CATEGORYS: 'Add category',
    SYSTEM_FIELD: 'System field',
    LAST_MODI_TIME: 'Last modified date',
    FIELD_TYPE: 'Field type',
    REQUIRED2: 'Required',
    PUBLIC: 'Public',
    AS_FILTER_KEY: 'Used as a filter',
    STACK_SHELVES: 'Release',
    WITHDRAW_SHELVES: 'Withdraw',
    MNT_CATEGORY: 'Maintenance category',
    IS_STACK: 'Whether to release?',
    SHOW_HAS_BEEN_WITHDRAWED_CATEGORY: 'Show the categories that have been withdrawed',
    MNT_CATEGORY_INFO: 'Maintenance category information',
    IS_DELETE_CATEGORY: 'Do you want to delete the selected category?',
    PLZ_USE_WITHDRAW: 'The categories that have been used cannot be deleted, please use the withdrawal function',
    SELECT_CATEGORY: 'Select category',
    VERSION_EXCEPTION: 'Version Exception',
    UN_INPUT_OPTION_EXIST: 'There are missing required fields',
    FIELD_NOT_ALLOWED_REPEAT: 'Fields are not allowed to repeat',
    DEFAULT_LANG_CATEGORY_NAME_REQUIRED: 'The name corresponding to the company’s default language is required',
    UNDER_SAME_PARENT_CATEGORY_NAME_NOT_ALLOWED_REPEAT: 'Category names cannot be repeated under the same superior maintenance category',
    UNDER_SAME_PARENT_CATEGORY_NO_NOT_ALLOWED_REPEAT: 'The serial number under the same superior maintenance category cannot be repeated',
    ID_CAN_NOT_EMPTY_WHEN_UPDATE: 'When updating, the DataID cannot be empty',
    PARENT_IS_WITHDRAWED: 'Superior maintenance is categorised as withdraw',
    UNDER_SAME_PARENT_PROP_ENG_NAME_NOT_ALLOWED_REPEAT: 'The English name of the category under the same superior item category cannot be repeated',
    UNDER_SAME_PARENT_PROP_NAME_NOT_ALLOWED_REPEAT: 'The category name cannot be repeated under the same superior item category',
    IS_WITHDRAW_CATEGORY: 'Do you want to remove the selected category?',
    WITHDRAW_SUCCESSFUL: 'Withdraw successfully',
    STACK_SUCCESSFUL: 'Released successful ',
    PROP_CATEGORY_INFO: 'Prop category information',
    DELETE_IMG: 'Delete photo',
    ExcelTemplate_common_000025: 'Default role',
    ExcelTemplate_common_000026: 'Default Orginazation ID',
    MNT_QUESTION_CATEGORY: 'Maintenance issue category',
    MNT_QUESTION: 'Maintenance issue',
    ExcelTemplate_common_000027: 'Use "|" to separate multiple tags',
    ExcelTemplate_common_000028: 'Mark * is a required field, it cannot be empty when importing',
    ExcelTemplate_common_000029: 'UserID for new users do not need to fill in, and the data at the time of export must be retained when importing and updating, as a key field for locating users during import',
    ExcelTemplate_common_000030: "Default organization ID, default organization path, default role field will also affect the user's default position when importing. See the second page for the specific logic. If it is not filled in, it will not affect the user's existing position",
    ExcelTemplate_common_000031: 'Other fields are not required. If they are not filled in during import, the corresponding fields in the system will be cleared.',
    ExcelTemplate_common_000032: 'Default organization path',
    MNT_QUESTION_CATEGORY_NAME: 'Maintenance issue category name',
    MNT_QUESTION_CATEGORY_INFO: 'Maintenance issue category infomation',
    MNT_QUESTION_INFO: 'Maintenance issue information',
    MNT_QUESTION_NAME: 'Maintenance issue name',
    ExcelTemplate_common_000041: 'Maintenance issue name',
    r_info_common_000091: 'Allow to view price',
    ExcelTemplate_common_000033: 'Maintenance issue ID',
    d_info_common_000091: 'Allow to view price',
    ExcelTemplate_common_000034: 'Required',
    ExcelTemplate_common_000035: '1. Do not modify the structure of the table, including deleting the notice column, or add, delete or modify the column of fields in the Excel table;',
    ExcelTemplate_common_000036: '2. The fields marked * are required, and cannot be empty when importing',
    ExcelTemplate_common_000037: "3. Maintenance issue ID is not necessary when importing new issues. When updating issues, issue ID must be kept as same as it's exported.",
    ExcelTemplate_common_000038: '4.Maintenance issue name contains multiple language versions. {{}}is required, other language is optional.',
    ExcelTemplate_common_000039: '5. Other fields are not required. If they are not filled in during import, the corresponding fields in the system will be cleared.',
    ExcelTemplate_common_000040: '6.Issue Category, default priority will be imported based on their {{}} name.',
    ExcelTemplate_common_000042: "3. Maintenance issue category ID is not necessary when importing new category. When updating category, category ID must be kept as same as it's exported.",
    ExcelTemplate_common_000043: '4.Maintenance issue category name contains multiple language versions. {{}}is required, other language is optional.',
    ExcelTemplate_common_000044: '5. If the optional fields are not filled in during import, the corresponding fields in the system will be cleared.',
    EXPORT_MNT_QUESTION: 'Export Issues',
    EXPORT_MNT_QUESTION_CATEGORY: 'Export Issue Categories',
    IS_DELETE_QUESTION: 'Do you want to delete the selected question?',
    DATA_HAS_BEEN_USED: 'The data has been used and cannot be deleted',
    CAN_NOT_REPEAT: 'Cannot be repeated',
    SAME_MNT_QUESTION_CATEGORY_QUESTION_NAME_CAN_NOT_REPEAT: 'The issue name cannot be repeated under the same maintenance issue category',
    DOWNLOAD_MNT_QUESTION_TEMPLATE: 'Download maintenence issue template',
    MNT_QUESTION_TEMPLATE: 'Maintenence issue template',
    DOWNLOAD_MNT_QUESTION_CATEGORY_TEMPLATE: 'Download issue category template',
    MNT_QUESTION_CATEGORY_TEMPLATE: 'Multilingual templates of category',
    worker_common_000114: 'Issue category is required',
    worker_common_000115: 'Invalid priority',
    worker_common_000116: 'The content of the default language cannot be empty',
    worker_common_000117: 'Invalid ID',
    worker_common_000118: 'Issue name repeated under same category',
    worker_common_000119: 'Category name repeated',
    POFIELD_SAVE_FIELDCLASS_MSG: 'A category named {0} already exists',
    POFIELD_SAVE_FIELD_MSG: 'An issue named {0} already exists in the same category',
    EXPORT_STORE: 'Export stores',
    DOWNLOAD_EXCEL_QYTEMPLATE: '企微预绑定模板下载',
    QY_PRE_BINDING: '企微预绑定',
    QYUSER: '企微人员',
    STORE_LONG_FORM: '店铺长表单',
    QYWX_CONFIG: '仅对企微所在部门为店铺的用户添加"成员"相关职位',
    STORE_INFO_AREASQUARE: '面积',
    STORE_INFO_OPENDATE: '开店时间',
    STORE_INFO_CLOSEDATE: '闭店时间',
    STORE_INFO_DECORATIONDATE: '最近装修时间',
    BINDING_QY_DEPARTMENT: '绑定企微部门',
    BINDING_QY_DEPARTMENT_DOWNLOAD: '下载绑定企微部门模板'
  },
  ...koLocale
}
